/* NZS-SPD-0808 — assets/nzs-header-drawer.js
   EXTRACTED from the inline <script> at sections/nzs-header.liquid:1076-2031 (the "Cart drawer
   disclosures" block: disclosures, the cart drawer itself, reward ladder, recs + recently-viewed
   tabs, the mobile nav drawer and the More menu). 69,377 B of inline JS off every page's HTML.

   ONE Liquid interpolation existed in the block and is BRIDGED, not inlined — everything else is
   byte-for-byte the original. The change, and only this change:
     was:  '<img class="nzs-cdr__pt-img" src="{{ 'nzs-ladder-truck.png' | asset_img_url: '104x' }}" ...>'
     now:  built from TRUCK_SRC, read from data-nzs-truck-src on #nzsCartDrawer, which
           sections/nzs-header.liquid:184 renders with that same asset_img_url filter.
   (The other `{{`/`}}`-looking hits in the block — cart.js fetch options, CustomEvent detail
   objects, the /cart/change payload — are JS object literals, not Liquid.)

   DEFER TIMING — checked, not assumed:
   * Every element it touches (#nzsCartToggle:32, #nzsCartOverlay:183, #nzsCartDrawer:184,
     #nzsHdrSpacer:335, #nzsBurger/#nzsMnav/#nzsMore) is rendered ABOVE line 1076, so nothing
     depends on this running mid-parse.
   * :1972 `if(document.readyState==='loading') addEventListener('DOMContentLoaded',cartEnhance)
     else cartEnhance()`. Inline it took the 'loading' branch and enhanced at DOMContentLoaded,
     by which time the deferred nzs-overlay.js had already defined window.nzsOverlay. Deferred it
     takes the else branch and enhances immediately — still AFTER nzs-overlay.js (defer preserves
     document order) so window.nzsOverlay is defined either way. Same end state, marginally
     earlier. Ditto mEnhance at :2010.
   * :2023-2026 register fallback closers in window.__nzsSurfaces only `if(!cartOverlay)` /
     `if(!mOverlay)`; nzsOverlay.enhance() registers the real ones. Both orders converge.
   * No document.write, no synchronous layout read that another parse-time script consumes.
   KNOWN COST: the cart-icon click handler (:1954) now binds after the full HTML parse instead of
   mid-header. On a slow connection there is a slightly longer window where tapping the cart icon
   does nothing. That window shrinks as the collection pages get smaller, which is this batch's
   whole point, but it is the one real behavioural risk in this move — see reports/L.md.
*/
/* ===== Cart drawer disclosures ===== */
(function(){
  var drawer=document.getElementById('nzsCartDrawer'); if(!drawer) return;
  var buttons=[].slice.call(drawer.querySelectorAll('[data-cdr-disclosure]')), byName={};
  function name(btn){ return btn.getAttribute('data-cdr-disclosure'); }
  function key(btn){ return 'nzs-cdr-'+name(btn)+'-open'; }
  function setDisclosure(btn,open){
    var panel=document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded',open?'true':'false');
    btn.parentNode.classList.toggle('is-expanded',open);
    if(panel){ panel.setAttribute('aria-hidden',open?'false':'true'); if(name(btn)==='recs') panel.hidden=!open; }
  }
  function setOnly(btn,open){
    buttons.forEach(function(other){
      var on=open&&other===btn;
      setDisclosure(other,on);
      try{ sessionStorage.setItem(key(other),on?'1':'0'); }catch(e){}
    });
  }
  var restored=null;
  buttons.forEach(function(btn){ byName[name(btn)]=btn; if(!restored){ try{ if(sessionStorage.getItem(key(btn))==='1') restored=btn; }catch(e){} } });
  setOnly(restored,!!restored);
  buttons.forEach(function(btn){
    btn.addEventListener('click',function(){ setOnly(btn,btn.getAttribute('aria-expanded')!=='true'); });
  });
  var pts=document.getElementById('nzsCdrRewardPts');
  if(pts&&byName.perks&&window.MutationObserver){
    new window.MutationObserver(function(){ if(byName.perks.getAttribute('aria-expanded')!=='true'&&pts.querySelector('.just-hit')) setOnly(byName.perks,true); }).observe(pts,{subtree:true,attributes:true,attributeFilter:['class']});
  }
})();

/* ===== Cart Drawer ===== */
(function(){
  var toggle = document.getElementById('nzsCartToggle');
  var overlay = document.getElementById('nzsCartOverlay');
  var drawer = document.getElementById('nzsCartDrawer');
  var closeBtn = document.getElementById('nzsCartClose');
  var itemsEl = document.getElementById('nzsCdrItems');
  var footEl = document.getElementById('nzsCdrFoot');
  var cntEl = document.getElementById('nzsCdrCount');
  var subtEl = document.getElementById('nzsCdrSubtotal');
  var dotEl = document.getElementById('nzsCartDot');
  if(!toggle||!drawer) return;
  var cartRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  /* NZS-SPD-0808: the one Liquid value this block used, bridged off the drawer element. */
  var TRUCK_SRC=(drawer&&drawer.getAttribute('data-nzs-truck-src'))||'';
  function money(c){ return '$'+(c/100).toFixed(2); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  /* Reward ladder — amounts in cents. NZS-OFFERS-0820: tiers now come from the
     Liquid-rendered #nzsCdrOffersCfg JSON in nzs-header.liquid (single source of truth for
     thresholds AND the gift pool); this array is only the fallback if that JSON is absent. */
  var REWARDS=[{amt:9900,label:'Free shipping',icon:'truck'}];
  try{
    var _cfgEl=document.getElementById('nzsCdrOffersCfg');
    if(_cfgEl){ var _cfg=JSON.parse(_cfgEl.textContent||'{}'); if(_cfg&&_cfg.tiers&&_cfg.tiers.length){ REWARDS=_cfg.tiers; window.__nzsCdrCfg=_cfg; } }
  }catch(_e){}
  function rwIcon(name){
    if(name==='truck') return TRUCK_SRC ? '<img class="nzs-cdr__pt-img" src="'+TRUCK_SRC+'" alt="" loading="lazy">' : ''; /* NZS-LADDER-TRUCK v2 (Blake 2026-07-31): custom shaker-truck mark, white-trimmed + transparent */
    if(name==='gift'){
      /* NZS-OFFERS-0820 r6: Blake's gift icon (Downloads) as a currentColor mask so it takes the
         reached/unreached state colours exactly like the old inline SVG did. */
      var _gs=(window.__nzsCdrCfg&&window.__nzsCdrCfg.gift)||'';
      if(_gs) return '<span class="nzs-cdr__gift-mask" style="-webkit-mask-image:url('+_gs+');mask-image:url('+_gs+')"></span>';
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
    }
    if(name==='star') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    if(name==='percent') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
    return '';
  }
  /* NZS-OFFERS-0820 r3: checkpoints are EVENLY spaced (proportional spacing crams $99/$155
     together at 4 tiers); the fill interpolates piecewise between checkpoint positions so it
     still reads as real progress. All thresholds/titles come from the config. */
  function ptPos(i){ return (i+1)/REWARDS.length*100; }
  function updateReward(cart){
    var wrap=document.getElementById('nzsCdrReward'); if(!wrap) return;
    if(!REWARDS.length||!cart.items||!cart.items.length){ wrap.style.display='none'; return; }
    wrap.style.display='';
    var sub=qualTotal(cart);
    var next=null, prevAmt=0, prevPos=0, nextPos=100, pct=100;
    for(var i=0;i<REWARDS.length;i++){
      if(sub<REWARDS[i].amt){ next=REWARDS[i]; nextPos=ptPos(i); prevPos=i>0?ptPos(i-1):0; prevAmt=i>0?REWARDS[i-1].amt:0; break; }
    }
    if(next){
      var frac=(sub-prevAmt)/(next.amt-prevAmt); if(!(frac>=0)) frac=0; if(frac>1) frac=1;
      pct=prevPos+frac*(nextPos-prevPos);
    }
    var fill=document.getElementById('nzsCdrRewardFill'); if(fill) fill.style.width=pct+'%';
    var msg=document.getElementById('nzsCdrRewardMsg');
    if(msg){
      if(next) msg.innerHTML=(next.opts&&next.opts.length)?'Spend <b>'+money(next.amt-sub)+'</b> more to unlock: <b>'+esc(next.label)+'</b>':'Spend <b>'+money(next.amt-sub)+'</b> more for '+esc(next.label.toLowerCase());
      else msg.innerHTML='You’ve unlocked '+(REWARDS.length>1?'all rewards':esc(REWARDS[REWARDS.length-1].label.toLowerCase()))+'! 🎉';
    }
    var pts=document.getElementById('nzsCdrRewardPts');
    if(pts){
      if(pts.children.length!==REWARDS.length){
        pts.innerHTML=REWARDS.map(function(r,i){
          var reached=sub>=r.amt;
          return '<div class="nzs-cdr__reward-pt'+(reached?' is-reached':'')+'" style="left:'+ptPos(i)+'%" title="'+esc(r.label)+' – '+money(r.amt)+'">'+rwIcon(r.icon)+'<span class="nzs-cdr__pt-lbl">'+moneyShort(r.amt)+'</span></div>';
        }).join('');
      } else {
        REWARDS.forEach(function(r,i){
          var el=pts.children[i]; if(!el) return;
          var reached=sub>=r.amt, wasReached=el.classList.contains('is-reached');
          if(reached&&!wasReached){
            el.classList.add('is-reached','just-hit');
            setTimeout(function(){ el.classList.remove('just-hit'); },500);
          } else if(!reached&&wasReached){
            el.classList.remove('is-reached');
          }
        });
      }
    }
  }
  function setBadge(n){
    if(dotEl){ dotEl.textContent=n; dotEl.style.display=n>0?'':'none'; }
    if(cntEl) cntEl.textContent=n;
  }
  /* NZS-ROUND4-E-RTD-JS: obsolete drawer promo loader and renderer removed. */
  /* NZS-UPSELL-0911: Section Rendering recommendations keyed on the top-value anchor plus the newest paid line.
     ponytail: fetch curated cards in one section instead of complementary and related API passes. */
  /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
  var recsKey='', recsSeq=0, recsAbort=null, recsFailUntil=0;
  var recsHead=document.querySelector('#nzsCdrRecs .nzs-cdr__recs-head');
  var recsHeading=recsHead?recsHead.textContent:'Customers Also Bought';
  function loadRecs(cart){
    var box=document.getElementById('nzsCdrRecs'), rowEl=document.getElementById('nzsCdrRecsRow');
    if(!box||!rowEl) return;
    var items=cart.items||[];
    if(!items.length){ ++recsSeq; if(recsAbort){ try{ recsAbort.abort(); }catch(_){} } box.style.display='none'; box.removeAttribute('data-done'); recsKey=''; return; } /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    /* NZS-UPSELL-0911: ponytail: one Liquid fetch instead of two recommendation API passes. */
    var inCart={}; items.forEach(function(it){ inCart[it.product_id]=1; });
    var paid=items.filter(function(it){ return !(it.properties||{})._nzs_gift; });
    if(!paid.length) paid=items;
    var byProd={}; paid.forEach(function(it){ var p=it.product_id, lp=it.final_line_price||it.price||0; if(byProd[p]==null||lp>byProd[p]) byProd[p]=lp; });
    /* NZS-UPSELL-0911: ponytail: read the top anchor directly instead of copying two sorted ids. */
    var anchors=Object.keys(byProd).sort(function(a,b){return byProd[b]-byProd[a];});
    var seeds=[Number(anchors[0])], newest=paid[paid.length-1].product_id;
    if(Number(newest)!==seeds[0]) seeds.push(Number(newest));
    var key=seeds.slice().sort().join(',');
    var seq=++recsSeq;
    if(recsAbort){ try{ recsAbort.abort(); }catch(_){} }
    rowEl.querySelectorAll('[data-rec-pid]').forEach(function(c){ if(inCart[c.getAttribute('data-rec-pid')]) c.remove(); });
    box.style.display=rowEl.children.length?'':'none';
    if(key===recsKey && box.getAttribute('data-done')==='1') return;
    if(recsFailUntil && Date.now()<recsFailUntil) return;
    recsAbort=(typeof AbortController==='function')?new AbortController():null;
    var url=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'search?section_id=nzs-cdr-recs&type=product&q='+encodeURIComponent(seeds.map(function(i){return 'id:'+i;}).join(' OR '));
    fetch(url,recsAbort?{signal:recsAbort.signal}:undefined)
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(html){
        if(seq!==recsSeq) return;
        var doc=new DOMParser().parseFromString(html,'text/html');
        var wrap=doc.querySelector('[data-cdr-recs-mode]');
        if(!wrap){ recsFailUntil=Date.now()+60000; return; }
        var kept=Array.prototype.filter.call(wrap.children,function(c){ return c.classList.contains('nzs-cdr__rec')&&!inCart[c.getAttribute('data-rec-pid')]; }).slice(0,8);
        rowEl.innerHTML='';
        kept.forEach(function(c){ rowEl.appendChild(c); });
        box.style.display=kept.length?'':'none'; box.setAttribute('data-done','1'); recsKey=key; recsFailUntil=0;
        var head=box.querySelector('.nzs-cdr__recs-head');
        if(head) head.textContent=wrap.getAttribute('data-cdr-recs-mode')==='fallback'?'Popular right now':recsHeading;
        rowEl.querySelectorAll('.nzs-cdr__rec[data-rec-pid]').forEach(function(c){
          var slot=c.querySelector('.nzs-cdr__rec-stars'); if(!slot) return;
          jmGet(c.getAttribute('data-rec-pid')).then(function(e){ var h=jmHtml(e); if(h) slot.innerHTML=h; });
        });
        if(drawer.classList.contains('is-open')) croEv('rec_impression',{surface:'cdr',n:kept.length,pids:kept.map(function(c){ return c.getAttribute('data-rec-pid'); }),mode:wrap.getAttribute('data-cdr-recs-mode')});
      })
      .catch(function(err){
        if(seq!==recsSeq || (err&&err.name==='AbortError')) return;
        recsFailUntil=Date.now()+60000;
      });
  }
  /* ===== NZS-CDR-RRP: cart.js has no compare_at_price, so enrich per-handle from /products/{handle}.js
     (memoised, same pattern as the RTD + recommendations fetches below). Map variant_id -> RRP cents. */
  var _rrp={}, _rrpReq={}, _lastCart=null;
  /* NZS-CDR-SUBUP: /products/<handle>.js also carries selling_plan_groups, so the RRP fetch below
     doubles as the plan fetch -- no extra request. _plansDirty tells render() to rebuild the rows
     once when a handle's plans first land, otherwise the unchanged-keys patch path would keep the
     old markup and the Subscribe pill would never appear. */
  var _plans={}, _plansDirty=false;
  function rrpFor(it){ var c=_rrp[it.variant_id]; return (c && c>it.price) ? c : 0; }
  function loadRrp(cart){
    var need=[];
    (cart.items||[]).forEach(function(it){
      if(!it.handle || _rrpReq[it.handle] || _rrp[it.variant_id]!==undefined) return;
      if(need.indexOf(it.handle)<0) need.push(it.handle);
    });
    if(!need.length) return;
    need.forEach(function(h){
      _rrpReq[h]=1;
      fetch('/products/'+h+'.js')
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(p){
          (p.variants||[]).forEach(function(v){ _rrp[v.id]=(v.compare_at_price!=null?v.compare_at_price:0); });
          /* NZS-CDR-SUBUP: only a handle that actually HAS plans can change the markup, so only that
             case earns the full rebuild -- a subscription-less product must not cost the drawer the
             flicker the RRP patch path exists to avoid. */
          if(_plans[h]===undefined){ _plans[h]=p.selling_plan_groups||[]; if(_plans[h].length) _plansDirty=true; }
          if(_lastCart) render(_lastCart);   /* re-render prices in place (same keys -> patch path, no flicker) */
        })
        .catch(function(){ /* unknown RRP: line simply shows no strikethrough */ });
    });
  }
  /* NZS-CDR-GIFTGATE: single owner of the blocked state, because render() has TWO exits -- the
     empty-cart early return below and the normal path. "Remove all items" on a gift-only cart takes
     the early one, so without calling this there too the anchor would stay greyed and untabbable
     over an empty cart, with the note still showing. */
  function coGate(blocked){
    var a=document.getElementById('nzsCdrCheckout'), n=document.getElementById('nzsCdrGiftnote');
    if(a){
      a.classList.toggle('is-blocked',blocked);
      if(blocked){ a.setAttribute('aria-disabled','true'); a.setAttribute('tabindex','-1'); }
      else { a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
    }
    if(n) n.hidden=!blocked;
  }
  function render(cart){
    currentCart=cart; /* NZS-CDR-COLLAPSE: last accepted server cart, read by effectiveItemCount(). */
    /* NZS-KITE-RM-0828: the NZS-NOSAMPLES stripper (Kite's auto-added free-samples
       placeholder, product 8957551313094) is removed — the Kite app is inactive. */
    /* NZS-OFFERS-0820 r3: tier-gift housekeeping. (1) A tier whose qualifying total (paid
       items only — a gift can never help unlock itself) has fallen below its threshold loses
       its gift lines: the automatic discount would stop applying and the line would silently
       start charging. (2) Gift units beyond the tier's entitlement are trimmed. Both are
       session-capped per tier so app re-adds can never loop; Pick-a-Card gifts (other
       _nzs_gift values) are never touched. */
    try{
      var _qt=qualTotal(cart);
      REWARDS.forEach(function(t){
        if(!t.opts||!t.opts.length) return;
        var _tp='tier-'+t.amt;
        var _gl=(cart.items||[]).filter(function(it){ return (it.properties||{})._nzs_gift===_tp; });
        if(!_gl.length) return;
        var _cap=1; t.opts.forEach(function(o){ if((o.qty|0)>_cap) _cap=o.qty|0; });
        var _units=_gl.reduce(function(a,b){ return a+b.quantity; },0);
        var _drop=[];
        if(_qt<t.amt) _drop=_gl;
        else if(_units>_cap) _drop=[_gl[_gl.length-1]];   /* trim the newest extra line */
        if(!_drop.length) return;
        var _ck='nzsTierDrop-'+t.amt, _n=parseInt(sessionStorage.getItem(_ck)||'0',10);
        if(_n>=4) return;
        sessionStorage.setItem(_ck,String(_n+1));
        _drop.forEach(function(l){
          fetch(cartRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:l.key,quantity:0}),__nzsCartGuardHandled:true}).catch(function(){});
        });
        var _dk={}; _drop.forEach(function(l){ _dk[l.key]=1; });
        var _gq=_drop.reduce(function(a,b){ return a+b.quantity; },0);
        cart.items=cart.items.filter(function(it){ return !_dk[it.key]; });
        cart.item_count=Math.max(0,(cart.item_count||0)-_gq);
      });
    }catch(_e){}
    var qty=Number(cart.item_count); if(!isFinite(qty)) qty=0;
    setBadge(qty);
    if(qty>0 && drawer.classList.contains('is-open') && window.__nzsCoPrefetch) window.__nzsCoPrefetch(); /* checkout prefetch lives in a separate IIFE (NZS-CDR-CHECKOUT) — namespaced global, guarded for absence */
    if(!cart.items||!cart.items.length){
      itemsEl.innerHTML='<div class="nzs-cdr__empty">Your cart is empty</div>';
      if(footEl) footEl.style.display='none';
      coGate(false);   /* NZS-CDR-GIFTGATE: an empty cart is not a gift-only cart */
      updateReward(cart);
      loadRecs(cart);
      offersAfterRender(cart);   /* NZS-OFFERS-0820 */
      return;
    }
    if(subtEl) subtEl.textContent=money(cart.total_price);
    /* Per-line discount resolution for the drawer display. Precedence (mutually exclusive,
       never double-counted): free gift (tier-aware via _earned: sample>=3, mystery>=4 picks) ->
       subscription -> stack % -> existing line discount. */
    _lastCart=cart; loadRrp(cart);                                          /* NZS-CDR-RRP */
    var _attrs=cart.attributes||{};
    var _cdrPk={}; (cart.items||[]).forEach(function(it){ var p=it.properties||{}; if(p._Stack && !p._Free && p.Category) _cdrPk[String(p.Category).toLowerCase()]=1; });
    var _picks=Object.keys(_cdrPk).length, _stackPct=_picks>=4?10:_picks>=2?5:0;
    function lineDiscPair(it){
      var props=it.properties||{}, qty=it.quantity||1, orig=it.original_line_price||it.final_line_price;
      var _rl=rrpFor(it)*qty;                                              /* NZS-CDR-RRP: compare-at line total, 0 if not on sale */
      var _old=Math.max(orig,_rl);                                         /* RRP folds into `old`, never stacks on a discount */
      if(props._nzs_gift){
        /* NZS-OFFERS-0820 r3: tier gifts are REAL products zeroed by the automatic "NZS Reward"
           discounts, so show the SERVER's price truth — final_line_price is 0 only when the
           discount genuinely applied, and the 80%-off reward shows its real discounted price.
           Pick-a-Card gifts are $0-priced products, so they resolve free here unchanged. */
        return {old:_old,nw:it.final_line_price,free:it.final_line_price===0};
      }
      if(props._Free){ var _earned=/mystery/i.test(props._Free)?_picks>=4:_picks>=3; return _earned?{old:_old,nw:0,free:true}:{old:_old,nw:orig}; }
      var spa=it.selling_plan_allocation;                                  /* subscription: real discount lives here, per-unit */
      if(spa&&spa.compare_at_price!=null&&spa.price!=null&&spa.compare_at_price>spa.price) return {old:Math.max(spa.compare_at_price*qty,_rl),nw:spa.price*qty};
      if(_stackPct>0&&props._Stack) return {old:_old,nw:Math.round(orig*(1-_stackPct/100))};  /* paid stack pick (one-time) */
      /* NZS-OFFERS-0820 r12 (Blake): a line the automatic reward discount zeroed server-side
         is a free gift even without _nzs_gift props (BXGY allocates to its own pick of eligible
         line) -- tag it and swap its stepper. orig>0 keeps genuinely $0-priced lines untouched. */
      return {old:_old,nw:it.final_line_price,free:it.final_line_price===0&&orig>0};
    }
    /* per-unit old/new, stashed on the row so the optimistic qty path can rescale them instantly */
    function _uo(it){ var q=it.quantity||1, p=lineDiscPair(it); return Math.round(p.old/q); }
    function _un(it){ var q=it.quantity||1, p=lineDiscPair(it); return p.free?0:Math.round(p.nw/q); }
    var _totalSave=cart.items.reduce(function(s,it){var p=lineDiscPair(it);return s+(p.old-p.nw);},0);
    var _savEl=document.getElementById('nzsCdrSavings'), _savAmt=document.getElementById('nzsCdrSavingsAmt');
    if(_savEl){ if(_totalSave>0){ _savEl.style.display=''; if(_savAmt)_savAmt.textContent='-'+money(_totalSave); } else { _savEl.style.display='none'; } }
    if(footEl) footEl.style.display='';
    /* NZS-CDR-GIFTGATE: every line is a gift -> nothing to pay for, so block Checkout. A gift is
       either a Pick-a-Card line (_nzs_gift) or one the pricing above already resolved to free (an
       EARNED stack sample / mystery gift). An UNEARNED _Free line still charges money, so it counts
       as PAID and unblocks -- the shopper really is buying something. Runs on every render, so it
       unblocks the moment a paid line lands. */
    coGate(cart.items.length>0 && cart.items.every(function(it){
      return !!(it.properties&&it.properties._nzs_gift) || lineDiscPair(it).free===true;
    }));
    /* per-item price markup, shared by the full rebuild and the in-place patch path below */
    function priceHtmlFor(it){
      var _pp=lineDiscPair(it), _sv=_pp.old-_pp.nw;
      return _pp.free
        ? '<div class="nzs-cdr__prices">'+(_pp.old>0?'<span class="nzs-cdr__item-price--old">'+money(_pp.old)+'</span>':'')+'<span class="nzs-cdr__item-price nzs-cdr__item-price--new nzs-cdr__free-pill">FREE</span></div>'   /* NZS-GIFTLOCK: a pick-a-card gift has no RRP, so striking through $0.00 would be noise */
        : (_sv>0
          ? '<div class="nzs-cdr__prices"><span class="nzs-cdr__item-price--old">'+money(_pp.old)+'</span><span class="nzs-cdr__item-price nzs-cdr__item-price--new">'+money(_pp.nw)+'</span></div><span class="nzs-cdr__item-save">Save '+money(_sv)+'</span>'
          : '<span class="nzs-cdr__item-price">'+money(_pp.nw)+'</span>');
    }
    /* same line keys as the current DOM (no add/remove) → patch qty/price in place instead of
       rebuilding, so images/scroll position don't flicker on a plain qty change */
    var _domKeys=Array.prototype.map.call(itemsEl.querySelectorAll('.nzs-cdr__item'),function(r){return r.dataset.key;});
    var _newKeys=cart.items.map(function(it){return it.key;});
    var _samePatch=_domKeys.length===_newKeys.length && _domKeys.every(function(k){return _newKeys.indexOf(k)>-1;});
    /* NZS-OFFERS-0820 r12: same keys but a flipped gift/lock state (reward discount zeroed a
       line, or it went back to paid) needs its controls swapped -- force the rebuild. */
    if(_samePatch){ _samePatch=cart.items.every(function(it){
      var row=itemsEl.querySelector('[data-key="'+it.key+'"]');
      var p=it.properties||{}, pp=lineDiscPair(it);
      var g=(!!p._nzs_gift||pp.free===true); /* NZS-KITE-RM-0828: Kite placeholder conditions removed */
      return !!row && (row.dataset.lock==='1')===g;
    }); }
    /* NZS-CDR-SUBUP: plans for a handle just landed. The keys have not changed, so the patch path
       would leave the rows as they were and the pill would never render -- take the rebuild once,
       then clear the flag so plain qty changes keep the no-flicker patch path. */
    if(_plansDirty){ _samePatch=false; _plansDirty=false; }
    if(_samePatch){
      cart.items.forEach(function(it){
        var row=itemsEl.querySelector('[data-key="'+it.key+'"]'); if(!row) return;
        row.dataset.unit=it.final_price; row.dataset.unitOld=_uo(it); row.dataset.unitNew=_un(it);
        row.style.display='';
        var qn=row.querySelector('.nzs-cdr__qty-n'); if(qn) qn.textContent=it.quantity;
        /* NZS-GIFTLOCK: the in-place patch path keeps the same DOM, so a locked row's static
           quantity lives in two places that both have to be refreshed here -- the chip text and
           data-lockqty. Re-picking a gift already in the cart merges into the same line key, which
           takes this path, not the full rebuild. */
        if(row.dataset.lock==='1'){ row.dataset.lockqty=it.quantity;
          var _gl=row.querySelector('.nzs-cdr__giftlock'); if(_gl) _gl.textContent='Free gift'+(it.quantity>1?' \u00d7 '+it.quantity:''); }
        row.querySelectorAll('[data-act]').forEach(function(b){ b.dataset.qty=it.quantity; });
        var pw=row.querySelector('.nzs-cdr__price-wrap'); if(pw) pw.innerHTML=priceHtmlFor(it);
      });
    } else {
      /* NZS-CDR-PERKROW (Blake 2026-07-31): a claimed email perk shows as its own line
         at the top of the cart. cart.js exposes cart attributes; the nzs-stack-lockdown
         function's ORDER branch grants the discount itself at checkout. */
      var _perkRow=(cart.attributes&&cart.attributes._EmailPerk==='pick-a-card')
        ? '<div class="nzs-cdr__perkrow"><span class="nzs-cdr__perkrow-ic">'+rwIcon('percent')+'</span><span><b>Subscriber perk</b>: 2.5% off your order, applied at checkout</span></div>' /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
        : '';
      itemsEl.innerHTML=_perkRow+cart.items.map(function(it){
        var title=esc(it.product_title||it.title||''), imageUrl=it.image?String(it.image):'';
        var img=imageUrl?'<img src="'+esc(imageUrl+(imageUrl.indexOf('?')>-1?'&width=144':'?width=144'))+'" alt="'+title+'" loading="lazy">':'';
        var vt=it.variant_title&&it.variant_title!=='Default Title'?'<div class="nzs-cdr__item-variant">'+esc(it.variant_title)+'</div>':'';
        var _sp=it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan?esc(it.selling_plan_allocation.selling_plan.name):'';
        var subHtml=_sp?'<div class="nzs-cdr__item-sub"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v6h6"/><path d="M21 12A9 9 0 0 0 6 5.3L3 8"/><path d="M21 22v-6h-6"/><path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"/></svg>'+_sp+'</div>':'';
        var url=esc(it.url||'#'), key=esc(it.key);
        /* NZS-GIFTLOCK: the free-samples placeholder is a promo line the customer never chose to buy —
           it is added/removed by the gift app, so the drawer shows it read-only: no qty stepper, no Remove. */
        var _dp=it.properties||{}, _pp2=lineDiscPair(it);
        var _discTag=_dp._nzs_gift?(_pp2.free?'Free gift reward':'Reward discount'):(_pp2.free?(_dp._Free?'Free with your Build Your Stack':'Free gift reward'):((_stackPct>0&&_dp._Stack&&!_dp._Free)?_stackPct+'% off your stack':''));
        /* NZS-GIFTLOCK covers two cases, both of which display as FREE (NZS-KITE-RM-0828:
           the Kite free-samples placeholder case is removed — app inactive):
             1. a "Pick a Card" gift (_nzs_gift, added at $0 by nzs-gift-popup.js),
             2. any line the pricing above already resolved to free -- i.e. an EARNED stack
                sample / mystery gift.
           An UNEARNED _Free line is NOT locked on purpose: it still charges full price, so the
           shopper must keep the stepper and Remove to be able to get rid of it. */
        var _isGift=(!!_dp._nzs_gift||_pp2.free===true);
        /* NZS-CDR-SUBUP: a gift is never offered a subscription -- it is not a purchase. A paid
           one-time line whose product has 10%-discount week plans gets the pill; an already-subscribed
           paid line gets the way back out; a product with no week plans gets neither. Plans are empty
           until the /products/<handle>.js fetch lands, which is what _plansDirty re-renders for. */
        var _subupHtml='';
        if(!_isGift){
          if(it.selling_plan_allocation){ _subupHtml='<button class="nzs-cdr__subundo" type="button" data-subup-undo="'+key+'"><span class="nzs-speed-label">Switch to one-time</span></button>'; }
          else { var _sPlans=subPlans(it.handle);
            if(_sPlans.length) _subupHtml='<button class="nzs-cdr__subup" type="button" data-subup="'+key+'" aria-expanded="false">Subscribe &amp; save 10%</button>'; }
        }
        var discHtml=_discTag?'<div class="nzs-cdr__item-disc"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M19 5 5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg><span>'+esc(_discTag)+'</span></div>':'';
        /* NZS-CDR-PRICE-UP (Blake 2026-08-03): price + Save move into .nzs-cdr__item-head next to the
           title; the stepper and the trash icon are the only things left on .nzs-cdr__item-row.
           .nzs-cdr__item-end is gone. Gift rows still emit neither a stepper nor a remove control. */
        var _rmBtn='<button class="nzs-cdr__item-remove" type="button" data-act="remove" data-key="'+key+'" title="Remove" aria-label="Remove '+title+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18" aria-hidden="true" focusable="false"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg></button>';
        /* r12: zeroed by the reward discount but customer-added -> tag + lock qty, KEEP Remove */
        var _organicFree=_isGift&&!_dp._nzs_gift&&!_dp._Free; /* NZS-KITE-RM-0828 */
        return '<div class="nzs-cdr__item"'+(_isGift?' data-lock="1" data-lockqty="'+it.quantity+'"':'')+' data-key="'+key+'" data-pid="'+it.product_id+'" data-variant="'+it.variant_id+'" data-unit="'+it.final_price+'" data-unit-old="'+_uo(it)+'" data-unit-new="'+_un(it)+'"><div class="nzs-cdr__thumb">'+(_isGift?'<span class="nzs-cdr__item-img">'+img+'</span>':'<a class="nzs-cdr__item-img" href="'+url+'">'+img+'</a>')+'</div><div class="nzs-cdr__item-body"><div class="nzs-cdr__item-head">'+(_isGift?'<span class="nzs-cdr__item-title nzs-cdr__item-title--plain">'+title+'</span>':'<a class="nzs-cdr__item-title" href="'+url+'">'+title+'</a>')+'<div class="nzs-cdr__price-wrap">'+priceHtmlFor(it)+'</div></div>'+(_isGift?'':jmRowFor(it))+vt+subHtml+discHtml+'<div class="nzs-cdr__item-row">'+(_isGift?'<span class="nzs-cdr__giftlock">Free gift'+(it.quantity>1?' \u00d7 '+it.quantity:'')+'</span>'+(_organicFree?_rmBtn:''):'<div class="nzs-cdr__qty"><button class="nzs-cdr__qty-btn" type="button" data-act="minus" data-key="'+key+'" data-qty="'+it.quantity+'" aria-label="Decrease quantity, '+title+'">&minus;</button><span class="nzs-cdr__qty-n">'+it.quantity+'</span><button class="nzs-cdr__qty-btn" type="button" data-act="plus" data-key="'+key+'" data-qty="'+it.quantity+'" aria-label="Increase quantity, '+title+'">+</button></div>'+_rmBtn+'')+'</div>'+_subupHtml+'</div></div>';   /* NZS-CDR-SUBUP: after .nzs-cdr__item-row, still inside .nzs-cdr__item-body */
      }).join('');
    }
    updateReward(cart);
    loadRecs(cart);
    applyPending();
    offersAfterRender(cart);   /* NZS-OFFERS-0820 */
  }
  /* optimistic qty/remove: instant local update + un-hide, debounced single /cart/change.js per
     line, delegated so it survives both the patch and the full-rebuild paths above */
  var pending={};
  var chgChain=Promise.resolve();
  /* NZS-CDR-COLLAPSE state. collapseByKey holds at most one live animation per line;
     lineIntent is a monotonic per-line click counter (never reset -- reusing a number could
     let an ancient animation match a future click); currentCart is the last accepted server
     cart, needed to decide whether a removal empties the cart. */
  var collapseByKey={}, lineIntent={}, currentCart=null;
  var cdrReduce=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  function cdrRow(key){ return itemsEl.querySelector('[data-key="'+key+'"]'); }
  function showBusy(row){
    if(!row) return;
    /* NZS-CDR-BUSY: hosted on the price wrap, not the thumbnail. is-busy hides the price stack
       underneath so the spinner lands exactly where the price was -- no overlap, no reflow. */
    var host=row.querySelector('.nzs-cdr__price-wrap'); if(!host||host.querySelector('.nzs-cdr__busy')) return;
    var sp=document.createElement('span'); sp.className='nzs-cdr__busy'; sp.setAttribute('aria-hidden','true');
    sp.innerHTML='<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" focusable="false"><circle cx="33" cy="33" r="30"></circle></svg>';
    host.appendChild(sp); host.classList.add('is-busy'); row.setAttribute('aria-busy','true');
  }
  function hideBusy(row){
    if(!row) return;
    row.removeAttribute('aria-busy');
    var host=row.querySelector('.nzs-cdr__price-wrap'); if(host) host.classList.remove('is-busy');
    var sp=row.querySelector('.nzs-cdr__busy'); if(sp&&sp.parentNode) sp.parentNode.removeChild(sp);
  }
  /* server quantities overridden by whatever is optimistically pending, so 'did that click
     empty the cart?' is answered against intent, not against stale DOM. */
  function effectiveItemCount(){
    var total=0, seen={};
    if(currentCart&&currentCart.items){
      currentCart.items.forEach(function(it){
        var k=String(it.key), owner=pending[k];
        seen[k]=1;
        total+=owner?owner.qty:(parseInt(it.quantity,10)||0);
      });
      Object.keys(pending).forEach(function(k){ if(!seen[k]) total+=parseInt(pending[k].qty,10)||0; });
      return total;
    }
    itemsEl.querySelectorAll('.nzs-cdr__item').forEach(function(row){
      var owner=pending[row.dataset.key], qn;
      if(owner){ total+=owner.qty; return; }
      qn=row.querySelector('.nzs-cdr__qty-n');
      total+=parseInt(qn?qn.textContent:(row.dataset.lockqty||0),10)||0;
    });
    return total;
  }
  function cancelCollapse(key,restore){
    var fx=collapseByKey[key], row;
    if(fx){ delete collapseByKey[key]; if(fx.animation) fx.animation.cancel(); if(fx.row) fx.row.classList.remove('is-collapsing'); }
    if(restore){ row=cdrRow(key); if(row){ row.classList.remove('is-collapsing'); row.style.display=''; } }
  }
  function finishCollapse(fx){
    if(collapseByKey[fx.key]!==fx){ fx.animation.cancel(); return; }
    var owner=pending[fx.key];
    var stillGoing=!owner||(owner===fx.owner&&owner.qty===0);
    delete collapseByKey[fx.key];
    /* hide BEFORE cancelling the fill:forwards effect, or the row flashes back at full height */
    if(fx.row.parentNode){ if(stillGoing) fx.row.style.display='none'; else fx.row.style.display=''; }
    fx.row.classList.remove('is-collapsing');
    fx.animation.cancel();
  }
  function beginCollapse(row,key,owner,intent){
    if(!row||pending[key]!==owner||owner.qty!==0||lineIntent[key]!==intent) return;
    cancelCollapse(key,false);
    /* last line out, reduced motion, or no WAAPI: hide instantly. The empty-cart branch is
       server-rendered, so animating the final row just delays it. */
    if(effectiveItemCount()===0||cdrReduce.matches||typeof row.animate!=='function'){ row.style.display='none'; return; }
    row.style.display='';
    row.classList.add('is-collapsing');
    var h=row.getBoundingClientRect().height;
    if(!h){ row.classList.remove('is-collapsing'); row.style.display='none'; return; }
    /* border-box means height:0 still floors at padding+border (14+14+1), so the row would stop
       at ~29px and then snap away. Collapse the box model in the same keyframes. */
    var _cs=getComputedStyle(row);
    var fx={key:key,row:row,owner:owner,intent:intent,animation:row.animate([
      {height:h+'px',paddingTop:_cs.paddingTop,paddingBottom:_cs.paddingBottom,borderBottomWidth:_cs.borderBottomWidth,opacity:1},
      {height:'0px',paddingTop:'0px',paddingBottom:'0px',borderBottomWidth:'0px',opacity:0}
    ],{duration:200,easing:'ease',fill:'forwards'})};
    collapseByKey[key]=fx;
    fx.animation.finished.then(function(){ finishCollapse(fx); },function(){});
  }
  function reflowTotals(){
    var sum=0, qsum=0, sav=0;
    itemsEl.querySelectorAll('.nzs-cdr__item').forEach(function(row){
      /* NZS-CDR-COLLAPSE: a collapsing row is still display:'' for 200ms. Counting it would
         make the subtotal, savings and badge visibly lag the animation. */
      if(row.style.display==='none'||row.classList.contains('is-collapsing')) return;
      /* NZS-GIFTLOCK: a locked row has no .nzs-cdr__qty-n to read, so fall back to the quantity
         stamped on the row -- otherwise every optimistic qty tweak on a paid line would briefly
         drop the gift's units out of the cart badge until the server response re-rendered. */
      var qn=row.querySelector('.nzs-cdr__qty-n'), q=parseInt(qn?qn.textContent:(row.dataset.lockqty||0),10)||0;
      sum+=(parseFloat(row.dataset.unit)||0)*q; qsum+=q;
      var uo=parseFloat(row.dataset.unitOld), un=parseFloat(row.dataset.unitNew);   /* NZS-CDR-RRP */
      if(!isNaN(uo)&&!isNaN(un)&&uo>un) sav+=(uo-un)*q;
    });
    if(subtEl) subtEl.textContent=money(sum);
    var _s=document.getElementById('nzsCdrSavings'), _sa=document.getElementById('nzsCdrSavingsAmt');
    if(_s){ if(sav>0){ _s.style.display=''; if(_sa) _sa.textContent='-'+money(sav); } else { _s.style.display='none'; } }
    setBadge(qsum);
  }
  function applyPending(){
    Object.keys(pending).forEach(function(k){
      var row=itemsEl.querySelector('[data-key="'+k+'"]'); if(!row) return;
      var nq=pending[k].qty;
      /* a rebuild render replaces the node and its pill: only restore one if this line's write
         is genuinely in flight. */
      if(pending[k].inflight) showBusy(row); else hideBusy(row);
      /* NZS-CDR-COLLAPSE: preserve ONLY the exact animation this owner started on this very
         node. If a render replaced the row, the old animation is orphaned and the replacement
         is hidden in the same task -- otherwise a row mid-removal reappears at full height. */
      if(nq===0){
        var fx=collapseByKey[k];
        var live=!!(fx&&fx.owner===pending[k]&&fx.row===row&&fx.intent===lineIntent[k]&&row.parentNode);
        if(!live) row.style.display='none';
      }
      else { cancelCollapse(k,true);
             var qn=row.querySelector('.nzs-cdr__qty-n'); if(qn) qn.textContent=nq;
             row.querySelectorAll('[data-act]').forEach(function(b){ b.dataset.qty=nq; }); }
    });
    if(Object.keys(pending).length) reflowTotals();
  }
  itemsEl.addEventListener('click',function(e){
    var btn=e.target.closest('[data-act]'); if(!btn) return;
    /* NZS-GIFTLOCK: the real lock. Locked rows render no [data-act] controls, but if one ever
       lands inside one (later render path, app injection, devtools) the optimistic qty/remove
       path refuses it here rather than queueing a /cart/change.js write. */
    if(btn.closest('.nzs-cdr__item[data-lock="1"]')) return;
    /* NZS-CDR-SUBUP: a selling_plan change re-keys the line, so a qty write debounced against the
       OLD key would 404 and bounce the row. The conversion is queued on chgChain and clears this
       flag when it settles; until then the stepper simply does not accept input. */
    if(_subBusy) return;
    var act=btn.dataset.act, key=btn.dataset.key, row=btn.closest('.nzs-cdr__item');
    var q=pending[key]?pending[key].qty:(parseInt(btn.dataset.qty,10)||0);
    var nq = act==='plus' ? q+1 : act==='minus' ? q-1 : 0;
    if(nq<0) nq=0;
    /* NZS-CDR-COLLAPSE: the owner object and its intent number exist BEFORE any DOM work so the
       animation can bind to this exact click. pending[key] is assigned here rather than after
       the optimistic paint; `q` above was already read, so nothing downstream changes. */
    if(pending[key]) clearTimeout(pending[key].timer);
    var _intent=(lineIntent[key]||0)+1; lineIntent[key]=_intent;
    var _owner={qty:nq,timer:null};
    pending[key]=_owner;
    if(row){
      /* NZS-CDR-BUSY (Blake 2026-08-03): no pill here. The click is answered optimistically and
         a write may sit in the 300ms debounce or queue behind another line -- showing a spinner
         through all of that reads as "still loading" long after the UI has settled. The pill is
         raised where the request actually starts instead. */
      if(nq===0){ beginCollapse(row,key,_owner,_intent); }
      else {
        cancelCollapse(key,true);
        row.style.display='';
        var qn=row.querySelector('.nzs-cdr__qty-n'); if(qn) qn.textContent=nq;
        row.querySelectorAll('[data-act]').forEach(function(b){ b.dataset.qty=nq; });
        var _un2=parseFloat(row.dataset.unitNew); if(isNaN(_un2)) _un2=parseFloat(row.dataset.unit)||0;
        var _uo2=parseFloat(row.dataset.unitOld); if(isNaN(_uo2)) _uo2=_un2;
        var pe=row.querySelector('.nzs-cdr__item-price');
        if(pe && !pe.classList.contains('nzs-cdr__free-pill')) pe.textContent=money(_un2*nq);
        var oe=row.querySelector('.nzs-cdr__item-price--old');                       /* NZS-CDR-RRP */
        if(oe) oe.textContent=money(_uo2*nq);
        var se=row.querySelector('.nzs-cdr__item-save');
        if(se && _uo2>_un2) se.textContent='Save '+money((_uo2-_un2)*nq);
      }
    }
    reflowTotals();
    _owner.timer=setTimeout(function(){
      chgChain=chgChain.then(function(){
        var seq=++_cartSeq;
        /* the write starts HERE -- past the debounce and at the head of the queue. */
        var _bo=pending[key]; if(_bo){ _bo.inflight=true; showBusy(cdrRow(key)); }
        var owner=pending[key], tq=owner?owner.qty:nq; /* NZS-ROUND4-B-OWNER: one object owns this write. */
        var variantId=parseInt(row&&row.dataset.variant,10)||0;
        var started=Date.now(), budget=5600;
        function retryDelay(r,attempt){
          var raw=r.headers&&r.headers.get&&r.headers.get('Retry-After'), ms=NaN;
          if(raw){
            var seconds=Number(raw);
            ms=isNaN(seconds)?Date.parse(raw)-Date.now():seconds*1000;
          }
          if(!(ms>=0)) ms=attempt===0?600:1500;
          return Math.min(ms,4000,Math.max(0,budget-(Date.now()-started)));
        }
        function changeLine(id,attempt){
          return fetch(cartRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:tq}),__nzsCartGuardHandled:true})
            .then(function(r){
              if(r.ok) return r.json();
              if((r.status===429||r.status>=500)&&attempt<2&&(Date.now()-started)<budget){
                return new Promise(function(resolve){ setTimeout(resolve,retryDelay(r,attempt)); })
                  .then(function(){ return changeLine(id,attempt+1); });
              }
              /* NZS-CDR-STOCKMSG-0821: keep Shopify's error body (422 stock cap says exactly
                 what happened, e.g. "All 2 ... are in your cart") instead of discarding it. */
              return r.json().catch(function(){ return null; }).then(function(body){
                var err=new Error("Couldn't update cart"); err.status=r.status;
                if(body&&(body.description||body.message)) err.cartMessage=String(body.description||body.message);
                throw err;
              });
            });
        }
        function writeChange(){
          return changeLine(key,0).catch(function(err){
            if((err.status===400||err.status===404)&&tq===0) return {nzsGone:true};
            if((err.status!==400&&err.status!==404)||!variantId) throw err;
            return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}})
              .then(function(r){ if(!r.ok) throw new Error("Couldn't update cart"); return r.json(); })
              .then(function(cart){
                var fresh=null;
                (cart.items||[]).some(function(it){
                  if(String(it.variant_id)===String(variantId)){ fresh=it; return true; }
                  return false;
                });
                if(!fresh){ var missing=new Error("Couldn't update cart"); missing.status=404; throw missing; }
                return changeLine(fresh.key,0);
              });
          });
        }
        return writeChange()
          .then(function(cart){
            if(owner&&pending[key]===owner){ delete pending[key];
              /* NZS-CDR-COLLAPSE: the write landed. Keep a removed row hidden (restore:false) --
               the render below rebuilds from server truth anyway; restoring it here would
               flash the row back for one frame. */
              var _sr=cdrRow(key); if(tq===0&&_sr) _sr.style.display='none';
              cancelCollapse(key,false); hideBusy(_sr); }
            if(seq!==_cartSeq||(cart&&cart.nzsGone)) return;
            if(cart && cart.items && cart.token){
              render(cart);
              setTimeout(function(){ if(seq===_cartSeq) fetchCart(); },1400);
            } else { fetchCart(); }
          })
          .catch(function(err){
            if(owner&&pending[key]===owner){ delete pending[key];
              /* NZS-CDR-COLLAPSE: the write did not land, so put the row back. Only this owner
               may do it -- a newer click's collapse must survive an older failure. */
              cancelCollapse(key,true); hideBusy(cdrRow(key)); reflowTotals(); }
            /* NZS-CDR-VERIFY-FAIL (Blake 2026-08-01): a thrown update is not proof the update
               failed -- a bot-challenge 200 with an HTML body lands here with the change already
               processed. Ask /cart.js what actually happened and only alarm when the intended
               quantity genuinely is not there. fetchCart() resyncs the UI either way. */
            fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}})
              .then(function(r){ return r.ok?r.json():null; })
              .catch(function(){ return null; })
              .then(function(cart){
                fetchCart();
                var applied=false;
                if(cart&&cart.items){
                  var line=null;
                  cart.items.some(function(it){
                    if(String(it.key)===String(key)||(variantId&&String(it.variant_id)===String(variantId))){ line=it; return true; }
                    return false;
                  });
                  applied = tq===0 ? !line : !!(line&&line.quantity===tq);
                }
                if(!applied){
                  /* NZS-CDR-STOCKMSG-0821: when Shopify told us WHY (stock cap), say that instead
                     of the generic alarm. Count parsed from its message; singular-aware. */
                  var detail={message:"Couldn't update your cart. Please try again"}; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
                  var cm=err&&err.cartMessage;
                  if(err&&err.status===422&&cm&&/your cart|only add|can’t add|can't add|sold out|availab|stock/i.test(cm)){
                    detail.title="Stock limit reached";
                    var m=/\b(?:all|only)\s+(\d+)\b/i.exec(cm), n=m?parseInt(m[1],10):0;
                    var pname=(line&&line.product_title)||"items";
                    if(n===1){
                      detail.message="The last one in stock is already in your cart.";
                    } else if(n>1){
                      var msg="All "+n+" "+pname+" are in your cart.";
                      if(msg.length>60) msg="All "+n+" items are in your cart.";
                      detail.message=msg;
                    } else {
                      detail.message=cm;
                    }
                  }
                  document.dispatchEvent(new CustomEvent('nzs:cart-error',{detail:detail}));
                }
              });
          });
      });
    },300);
  });
  var _cartSeq=0, _cartReady=false, _cartRetryTimer=null, _cartRetryN=0;
  function fetchOnce(seq){
    var ctl=('AbortController' in window)?new AbortController():null, t=setTimeout(function(){ if(ctl) ctl.abort(); }, 8000);
    var p=fetch(cartRoot+'cart.js', ctl?{signal:ctl.signal}:{});
    p.then(function(){ clearTimeout(t); }, function(){ clearTimeout(t); });
    return p.then(function(r){ if(!r.ok) throw 0; return r.json();}).then(function(c){ if(seq!==_cartSeq) return; if(c && c.items && c.token){ _cartRetryN=0; _cartReady=true; render(c); } else { throw 0; } });
  }
  function fetchCart(){ var seq=++_cartSeq;
    return fetchOnce(seq)
      .catch(function(){ /* ponytail: one retry so a transient /cart.js blip never leaves the drawer stuck empty */
        return fetchOnce(seq).catch(function(){
          /* NZS-CDR-RETRY: both attempts failed. ponytail: 3 auto retries per open (counter resets on success/open), then manual tap only; no infinite polling. */
          if(seq!==_cartSeq || !drawer.classList.contains('is-open')) return;
          itemsEl.innerHTML='<div class="nzs-cdr__empty nzs-cdr__retry">Couldn\'t load your cart.<br><button type="button" class="nzs-cdr__retrybtn">Tap to retry</button></div>';
          if(!_cartRetryTimer && _cartRetryN<3){ _cartRetryN++; _cartRetryTimer=setTimeout(function(){ _cartRetryTimer=null; if(drawer.classList.contains('is-open') && !_cartReady) fetchCart(); }, 2000); }
        });
      });
  }
  /* NZS-CART-DRAWER-GIFT-RESYNC */
  var _foreignWriteTimer=null;
  document.addEventListener('nzs:cart-foreign-write',function(){
    if(!drawer.classList.contains('is-open')) return;
    clearTimeout(_foreignWriteTimer);
    _foreignWriteTimer=setTimeout(function(){
      _foreignWriteTimer=null;
      if(drawer.classList.contains('is-open')) fetchCart();
    },600);
  });
  itemsEl.addEventListener('click',function(e){
    var rb=e.target.closest('.nzs-cdr__retrybtn'); if(!rb) return;
    itemsEl.innerHTML='<div class="nzs-cdr__empty">Loading\u2026</div>';
    fetchCart();
  });
  /* ===== NZS-CDR-SUBUP: per-line "Subscribe & save 10%" ==============================
     Filter and default cadence are the PDP's (nzs-pdp-enhance.liquid), so a line converted here
     lands on the same plan the product page would have picked. Own delegated listener on
     [data-subup*] -- the [data-act] delegation above stays qty/remove only. */
  function subPlans(h){
    var out=[];
    (_plans[h]||[]).forEach(function(g){
      (g.selling_plans||[]).forEach(function(sp){
        var nm=String(sp.name||'').toLowerCase();
        if(nm.indexOf('week')<0 || nm.indexOf('10% discount')<0) return;   /* 15% is stack-only, never offered here */
        var wk=parseInt(String(sp.name).split(' ')[0].split('-')[0],10);
        if(!(wk>0)) return;
        out.push({w:wk,id:sp.id});
      });
    });
    out.sort(function(a,b){ return a.w-b.w; });
    return out;
  }
  /* Default the cadence to how long the tub lasts (1 serve/day => 7 a week): the largest plan week
     it covers, else the first >= 6 weeks, else the shortest. Same ladder as the PDP slider. */
  function subDefault(plans,title){
    var m=String(title||'').match(/(\d+)\s*serv/i), sv=m?parseInt(m[1],10):0, def=-1, i, j;
    if(sv>0){ var wkSup=Math.floor(sv/7); for(i=0;i<plans.length;i++){ if(plans[i].w<=wkSup) def=i; } }
    if(def<0){ for(j=0;j<plans.length;j++){ if(plans[j].w>=6){ def=j; break; } } }
    return def<0?0:def;
  }
  var _subBusy=false;
  function subLine(key){ return ((_lastCart&&_lastCart.items)||[]).filter(function(x){ return x.key===key; })[0]; }
  function subWks(n){ return n+' week'+(n===1?'':'s'); }
  /* Open state is read off the DOM, never cached: a full rebuild throws the panel away without
     telling us, and a stale "it's open" flag would make the next pill click a dead close. */
  function subPanelFor(key){
    var ps=itemsEl.querySelectorAll('.nzs-cdr__subpanel');
    for(var i=0;i<ps.length;i++){ if(ps[i].getAttribute('data-subup-panel')===key) return ps[i]; }
    return null;
  }
  function subClose(){
    itemsEl.querySelectorAll('.nzs-cdr__subpanel').forEach(function(p){ p.parentNode.removeChild(p); });
    itemsEl.querySelectorAll('[data-subup]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
  }
  function subShow(btn,key){
    var line=subLine(key); if(!line) return;
    var plans=subPlans(line.handle); if(!plans.length) return;
    subClose();                                       /* one panel at a time */
    var def=subDefault(plans,line.product_title), last=plans.length-1, pid='nzsSubp-'+key;
    var p=document.createElement('div');
    p.className='nzs-cdr__subpanel';
    p.id=pid;
    p.setAttribute('data-subup-panel',key);
    p.setAttribute('role','group');
    p.setAttribute('aria-label','Subscription frequency');
    p.innerHTML='<div class="nzs-cdr__subpanel-eye">Auto-ship</div>'
      +'<div class="nzs-cdr__subpanel-val" data-subup-val aria-live="polite">Every '+subWks(plans[def].w)+'</div>'
      +'<input type="range" class="nzs-cdr__subrange" data-subup-range="'+esc(key)+'" min="0" max="'+last+'" step="1" value="'+def+'" aria-label="Weeks between deliveries">'
      +'<div class="nzs-cdr__subpanel-ends"><span>'+plans[0].w+' wk'+(plans[0].w===1?'':'s')+'</span><span>'+plans[last].w+' wk'+(plans[last].w===1?'':'s')+'</span></div>'
      +'<div class="nzs-cdr__subpanel-act">'
      +'<button type="button" class="nzs-cdr__subok" data-subup-confirm="'+esc(key)+'"><span class="nzs-speed-label">Confirm</span></button>'
      +'<button type="button" class="nzs-cdr__subcancel" data-subup-cancel="'+esc(key)+'">Cancel</button></div>';
    btn.parentNode.insertBefore(p,btn.nextSibling);
    btn.setAttribute('aria-expanded','true');
    btn.setAttribute('aria-controls',pid);
  }
  function subPost(k,plan){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:k,selling_plan:plan})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); });
  }
  /* A selling_plan change RE-KEYS the line, so the key on the button is only good for finding the
     variant. Bump _cartSeq first (the NZS-CDR-CLEAR guard) so any /cart.js already in flight is
     ignored, re-GET the cart, then match by variant_id -- the assets/nzs-stack-retier.js pattern.
     `want` disambiguates when the same variant sits in the cart twice, once one-time and once
     subscribed. Queued on chgChain so it can never interleave with a debounced qty write. The
     change response IS the new cart, so it goes straight to render(). */
  function subApply(key,plan,ctl){
    if(_subBusy) return;
    _subBusy=true;
    /* NZS-SPEED-LDR-SUBUP: shared dots plus a dimmed, aria-busy subscription panel. */
    var busyPanel=ctl&&ctl.closest('.nzs-cdr__subpanel');
    function subBusyOff(){ if(ctl){ if(window.__nzsLoadOff) window.__nzsLoadOff(ctl); ctl.disabled=false; } if(busyPanel){ busyPanel.classList.remove('is-busy'); busyPanel.removeAttribute('aria-busy'); } }
    if(ctl){ ctl.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(ctl); }
    if(busyPanel){ busyPanel.classList.add('is-busy'); busyPanel.setAttribute('aria-busy','true'); }
    var l0=subLine(key), vid=l0&&l0.variant_id, want=!plan;
    var seq=++_cartSeq;
    chgChain=chgChain.then(function(){
      return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(c){
          var same=(c.items||[]).filter(function(x){ return x.variant_id===vid; });
          var line=same.filter(function(x){ return !!x.selling_plan_allocation===want; })[0]||same[0];
          if(!line) throw 0;                          /* gone (another tab / another surface) -> resync */
          /* Snapshot the OTHER subscribed keys for this variant so the undo retry below can never
             be aimed at one of them. Without this, un-subscribing line A of a variant the shopper
             also holds subscribed as line B could find B and silently convert it. */
          var preSub=same.filter(function(x){ return !!x.selling_plan_allocation; }).map(function(x){ return x.key; });
          /* NZS-CDR-SUBFIX: null is the documented clear and works here, but the old
             fallback was gated on the line's key having MOVED -- and a key only moves when the
             post actually did something, so the retry could never fire in the one case it existed
             for. Escalate instead: null -> '' -> remove + re-add one-time. Each step is tolerant,
             so a rejected retry falls through to the next rather than killing the chain. */
          function stillSub(c){ return ((c&&c.items)||[]).filter(function(x){ return x.variant_id===vid && x.selling_plan_allocation; }); }
          function tryPost(k,p,fallbackCart){ return subPost(k,p).catch(function(){ return fallbackCart; }); }
          return subPost(line.key,plan).then(function(c2){
            if(plan) return c2;
            var s2=stillSub(c2);
            if(s2.length<preSub.length) return c2;   /* a subscribed line went away -> null worked */
            /* prefer the line we just posted (its key moved), else the original key, which is
               exactly what a silent no-op leaves behind */
            var t2=s2.filter(function(x){ return preSub.indexOf(x.key)<0; })[0]
                 || s2.filter(function(x){ return x.key===line.key; })[0] || s2[0];
            if(!t2) return c2;
            return tryPost(t2.key,'',c2).then(function(c3){
              var s3=stillSub(c3);
              if(s3.length<preSub.length) return c3;
              /* Last resort: the allocation will not clear in place, so drop the line and re-add
                 the variant one-time. Quantity and properties are carried over; the line moves to
                 the end of the cart, which is the acceptable cost of it actually working. */
              var t3=s3.filter(function(x){ return x.key===t2.key; })[0]||s3[0];
              if(!t3) return c3;
              return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                body:JSON.stringify({id:t3.key,quantity:0})})
                .then(function(r){ if(!r.ok) throw 0; return r.json(); })
                .then(function(){
                  if(!window.nzsATC) throw new Error("Couldn't add to cart");
                  return window.nzsATC.add(
                    {items:[{id:t3.variant_id,quantity:t3.quantity,properties:t3.properties||{}}]},
                    {handle:t3.handle}
                  );
                })
                .then(function(){ return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}}); })
                .then(function(r){ if(!r.ok) throw 0; return r.json(); })
                .catch(function(){ return c3; });
            });
          });
        })
        .then(function(c3){
          _subBusy=false;
          subBusyOff();
          /* NZS-CDR-SUBFIX: a newer /cart.js read won the race. The old code returned here,
             which left the drawer painted with the PRE-toggle rows -- indistinguishable from
             "the toggle did nothing". Re-sync so the UI always ends on the truth. */
          if(seq!==_cartSeq){ fetchCart(); return; }
          if(c3&&c3.items&&c3.token) render(c3); else fetchCart();
        })
        .catch(function(){ _subBusy=false; subBusyOff(); fetchCart(); });
    });
  }
  itemsEl.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var b=t.closest('[data-subup]');
    if(b){ e.preventDefault(); var bk=b.getAttribute('data-subup');
      if(subPanelFor(bk)) subClose(); else subShow(b,bk); return; }
    var c=t.closest('[data-subup-cancel]');
    if(c){ e.preventDefault(); subClose(); return; }
    var ok=t.closest('[data-subup-confirm]');
    if(ok){ e.preventDefault();
      var key=ok.getAttribute('data-subup-confirm'), line=subLine(key), plans=line?subPlans(line.handle):[];
      var panel=ok.closest('.nzs-cdr__subpanel'), rg=panel&&panel.querySelector('[data-subup-range]');
      var i=rg?Math.max(0,Math.min(plans.length-1,parseInt(rg.value,10)||0)):0;
      if(plans[i]) subApply(key,plans[i].id,ok);
      return; }
    var u=t.closest('[data-subup-undo]');
    if(u){ e.preventDefault(); subApply(u.getAttribute('data-subup-undo'),null,u); return; }
  });
  itemsEl.addEventListener('input',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var rg=t.closest('[data-subup-range]'); if(!rg) return;
    var line=subLine(rg.getAttribute('data-subup-range')), plans=line?subPlans(line.handle):[];
    if(!plans.length) return;
    var i=Math.max(0,Math.min(plans.length-1,parseInt(rg.value,10)||0));
    var panel=rg.closest('.nzs-cdr__subpanel'), v=panel&&panel.querySelector('[data-subup-val]');
    if(v) v.textContent='Every '+subWks(plans[i].w);
  });
  var cartOverlay = null;
  /* ===== NZS-CDR-TABS ============================================================
     Pane switching is attribute-driven (aria-selected + hidden/inert) with a roving tabindex.
     The RV pane is filled from sections/nzs-cdr-rv.liquid through the Section Rendering API;
     localStorage is re-read on every activation because the `storage` event does not fire in
     the tab that wrote it, so a PDP viewed in THIS tab would otherwise never show up. */
  var rvPane=document.getElementById('nzsCdrPaneRv'), rvBox=document.getElementById('nzsCdrRv');
  var tabCart=document.getElementById('nzsCdrTabCart'), tabRv=document.getElementById('nzsCdrTabRv');
  var tabOffers=document.getElementById('nzsCdrTabOffers'), offersPane=document.getElementById('nzsCdrPaneOffers'), offersBox=document.getElementById('nzsCdrOffers');   /* NZS-OFFERS-0820 */
  var rvSeq=0, rvAbort=null, rvLoadedFor='';
  function rvIds(){
    var raw='[]', list=[];
    try{ raw=localStorage.getItem('recently-viewed')||'[]'; }catch(_){}
    try{ list=JSON.parse(raw); }catch(_){ list=[]; }
    if(!list||typeof list.length!=='number') list=[];
    var out=[], seen={};
    for(var i=0;i<list.length&&out.length<8;i++){
      var id=String(list[i]);
      if(!/^[0-9]+$/.test(id)||seen[id]) continue;
      seen[id]=1; out.push(id);
    }
    return out;
  }
  function rvLoad(){
    if(!rvBox) return;
    var ids=rvIds(), sig=ids.join(',');
    if(sig===rvLoadedFor&&rvBox.children.length) return;   /* already showing exactly this list */
    var seq=++rvSeq;
    if(rvAbort){ try{ rvAbort.abort(); }catch(_){} }
    rvAbort=(typeof AbortController==='function')?new AbortController():null;
    if(!rvBox.children.length) rvBox.innerHTML='<div class="nzs-cdr__rv-msg">Loading\u2026</div>';
    /* no history: ask for an id that cannot match, and the section falls through to best-sellers */
    var q=ids.length?ids.map(function(i){ return 'id:'+i; }).join(' OR '):'id:0';
    var url=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'search?section_id=nzs-cdr-rv&type=product&q='+encodeURIComponent(q);
    fetch(url,rvAbort?{signal:rvAbort.signal}:undefined)
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(html){
        if(seq!==rvSeq) return;                            /* a newer activation won */
        var doc=new DOMParser().parseFromString(html,'text/html');
        var box=doc.querySelector('[data-cdr-rv-mode]');
        /* a Shopify error page answers 200 with no section in it -- treat that as a failure */
        if(!box||!box.children.length){ rvBox.innerHTML='<div class="nzs-cdr__rv-msg">Nothing here yet</div>'; rvLoadedFor=''; return; }
        var head=box.getAttribute('data-cdr-rv-mode')==='fallback'?'<div class="nzs-cdr__rv-msg">Popular right now</div>':'';
        rvBox.innerHTML=head+box.innerHTML;
        rvLoadedFor=sig;
      })
      .catch(function(){
        if(seq!==rvSeq) return;
        rvBox.innerHTML='<div class="nzs-cdr__rv-msg">Nothing here yet</div>'; rvLoadedFor='';
      });
  }
  /* NZS-OFFERS-0820: generic 3-tab switcher (Cart | Offers | Recently Viewed). Filters out
     absent elements so a template without the Offers pane degrades to the old two-tab drawer. */
  function selectTab(name,opts){
    if(!tabCart) return;
    var reg=[
      {n:'cart',tab:tabCart,pane:document.getElementById('nzsCdrPaneCart')},
      {n:'offers',tab:tabOffers,pane:offersPane},
      {n:'rv',tab:tabRv,pane:rvPane}
    ].filter(function(r){ return r.tab&&r.pane; });
    var cur=null;
    reg.forEach(function(r){
      var on=r.n===name; if(on) cur=r;
      r.tab.setAttribute('aria-selected',on?'true':'false');
      r.tab.classList.toggle('is-on',on);
      r.tab.tabIndex=on?0:-1;
      r.pane.hidden=!on; if('inert' in r.pane) r.pane.inert=!on;
    });
    if(!cur) return;
    if(name==='rv') rvLoad();
    if(name==='offers'){ renderOffers(); croEv('offers_tab_viewed'); }
    if(opts&&opts.focus) cur.tab.focus();
  }
  var TAB_ORDER=[{n:'cart',t:tabCart},{n:'offers',t:tabOffers},{n:'rv',t:tabRv}].filter(function(x){ return x.t; });
  TAB_ORDER.forEach(function(x,i){
    x.t.addEventListener('click',function(){ selectTab(x.n,{focus:false}); });
    x.t.addEventListener('keydown',function(e){
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight') return;
      e.preventDefault();
      var j=(i+(e.key==='ArrowRight'?1:TAB_ORDER.length-1))%TAB_ORDER.length;
      selectTab(TAB_ORDER[j].n,{focus:true});
    });
  });
  /* the RV pane's Add buttons are .nzs-cdr__rec-add, the same contract the recs row uses, but
     that delegate is bound to #nzsCdrRecsRow -- bind the twin here. */
  if(rvBox) rvBox.addEventListener('click',function(e){
    var btn=e.target.closest('[data-rec-add]'); if(!btn||btn.disabled) return;
    var vid=parseInt(btn.dataset.recAdd,10); if(!vid) return;
    if(window.__nzsLoadOn) window.__nzsLoadOn(btn);
    var add=window.nzsATC?window.nzsATC.add({items:[{id:vid,quantity:1}]},{}):Promise.reject(new Error('Please try again'));
    add.then(function(){ if(window.__nzsLoadOff) window.__nzsLoadOff(btn); recsKey=''; fetchCart(); selectTab('cart',{focus:false}); })
       .catch(function(){ if(window.__nzsLoadOff) window.__nzsLoadOff(btn); });
  });
  /* ===== NZS-OFFERS-0820 r3: Offers pane + schema-driven multi-tier gifts + review stars ====
     Entitlement types (from config, no product-specific branches):
       single       — one product, one tap
       flavour_pick — one product family, inline flavour list (split-product store: flavours ARE
                      sibling products)
       multi_pick   — choose N from a pool (optional duplicates), count UI
       random_pool  — N random distinct in-stock items from the pool
       'flat' is flattened into singles at Liquid render.
     Pricing authority = the automatic "NZS Reward" BXGY discounts; lines carry
     properties._nzs_gift='tier-<amt-cents>' for tracking/locking/housekeeping only. */
  function croEv(ev,d){ try{ document.dispatchEvent(new CustomEvent('nzs:cro',{detail:Object.assign({ev:ev},d||{})})); }catch(_e){} }
  function moneyShort(c){ return c%100===0?('$'+(c/100)):money(c); }
  function tierProp(t){ return 'tier-'+t.amt; }
  function tierLines(cart,t){
    var p=tierProp(t);
    return ((cart&&cart.items)||[]).filter(function(it){ return (it.properties||{})._nzs_gift===p; });
  }
  /* qualifying total: paid items only — an UNEARNED gift line (discount not applying) must not
     count toward unlocking its own tier. Earned gift lines are $0 so subtracting is a no-op. */
  function qualTotal(cart){
    var tot=(cart&&cart.total_price)||0;
    ((cart&&cart.items)||[]).forEach(function(it){
      var g=(it.properties||{})._nzs_gift;
      if(g&&String(g).indexOf('tier-')===0) tot-=it.final_line_price||0;
    });
    return tot;
  }
  function optAvail(o){
    var av=(o.items||[]).filter(function(g){ return g.av!==false; });
    if(o.type==='multi_pick'&&!o.dup&&av.length<(o.qty|0)) return [];
    if(o.type==='random_pool'&&av.length<1) return [];
    return av;
  }
  var CHECK_IMG='<img src="'+esc((window.__nzsCdrCfg&&window.__nzsCdrCfg.check)||'')+'" alt="" width="15" height="15" loading="lazy">';
  var CHECK_IMG22='<img src="'+esc((window.__nzsCdrCfg&&window.__nzsCdrCfg.check)||'')+'" alt="" width="22" height="22" loading="lazy">';   /* NZS-OFFERS-0820 r8 */
  function renderOffers(){
    if(!offersBox) return;
    var cart=currentCart||{items:[],total_price:0};
    var sub=qualTotal(cart);
    offersBox.innerHTML=REWARDS.map(function(t,ti){
      var un=sub>=t.amt, isGift=!!(t.opts&&t.opts.length);
      var head='<span class="nzs-cdr__offer-ic">'+(rwIcon(t.icon)||rwIcon('gift'))+'</span>';
      var name='<div class="nzs-cdr__offer-name">'+esc(t.label)+' at '+moneyShort(t.amt)+'</div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      var body, act='';
      if(!isGift){
        body=un?'<span class="nzs-cdr__offer-state">'+CHECK_IMG+' Unlocked</span>'
               :'<div class="nzs-cdr__offer-sub">Add <b>'+money(t.amt-sub)+'</b> more for <b>'+esc(t.label)+'</b></div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      } else {
        var lines=tierLines(cart,t);
        var live=t.opts.filter(function(o){ return optAvail(o).length; });
        var thumbs='';
        if(!lines.length){
          /* NZS-OFFERS-0820 r6: every live option contributes its first image FIRST (so a
             one-option-per-family reward like the Macro Mike pack is always represented),
             then remaining flavours fill up to 6. */
          var seen={}, imgs=[];
          function takeImg(g){ if(g&&g.av!==false&&g.img&&!seen[g.img]&&imgs.length<6){ seen[g.img]=1; imgs.push(g.img); } }
          live.forEach(function(o){ takeImg(optAvail(o)[0]); });
          live.forEach(function(o){ (o.items||[]).forEach(takeImg); });
          thumbs=imgs.length?'<div class="nzs-cdr__offer-thumbs">'+imgs.map(function(u){ return '<img src="'+esc(u)+'" alt="" loading="lazy" width="40" height="40">'; }).join('')+'</div>':'';
        }
        if(lines.length){
          var names=lines.map(function(l){ return esc(l.product_title||l.title||''); });
          var label=names.slice(0,2).join(', ')+(names.length>2?' +'+(names.length-2):'');
          body='<span class="nzs-cdr__offer-state">'+CHECK_IMG+' Added: '+label+'</span>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
          act='<button type="button" class="nzs-cdr__offer-pick nzs-cdr__offer-pick--view" data-offer-pick="'+t.amt+'">Change selection</button>';
        } else if(un){
          if(!live.length){ body='<div class="nzs-cdr__offer-sub">Gift options are out of stock right now. Back soon.</div>'; } /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
          else {
            body=thumbs+'<div class="nzs-cdr__offer-sub">Unlocked: <b>'+esc(t.label)+'</b>'+(t.desc?'. '+esc(t.desc):'')+'</div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
            act='<button type="button" class="nzs-cdr__offer-pick" data-offer-pick="'+t.amt+'">Select gift</button>';
          }
        } else {
          body=thumbs+'<div class="nzs-cdr__offer-sub">Add <b>'+money(t.amt-sub)+'</b> more for <b>'+esc(t.label)+'</b></div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
          if(live.length) act='<button type="button" class="nzs-cdr__offer-pick nzs-cdr__offer-pick--view" data-offer-view="'+t.amt+'">View gifts</button>';
        }
      }
      return '<div class="nzs-cdr__offer '+(un?'is-unlocked':'is-locked')+'" style="--gm-i:'+ti+'"><div class="nzs-cdr__offer-main">'+head+'<div class="nzs-cdr__offer-body">'+name+body+'</div><div class="nzs-cdr__offer-act">'+act+'</div></div></div>';
    }).join('');
  }
  if(offersBox) offersBox.addEventListener('click',function(e){
    var b=e.target.closest('[data-offer-pick],[data-offer-view]'); if(!b) return;
    var view=b.hasAttribute('data-offer-view');
    var amt=parseInt(b.getAttribute(view?'data-offer-view':'data-offer-pick'),10), t=null;
    REWARDS.forEach(function(r){ if(r.amt===amt&&r.opts&&r.opts.length) t=r; });
    if(t){ croEv('gift_selector_opened',{amt:amt,view:view}); gmOpen([t],view); }
  });
  /* --- gift-selection modal --- */
  /* NZS-OFFERS-0820-R4-GMDIV: option/sub cards are role=radio DIVS - nested <button>s are
     invalid HTML and get ejected by the parser. Inner qty steppers stay real buttons. */
  var gmEl=document.getElementById('nzsCdrGm');
  var gmQueue=[], gmIdx=0, gmBusyFlag=false, gmLastFocus=null, gmViewOnly=false;
  var gmOpt=null, gmPicks={};                       /* selected option + {vid:qty} */
  function gmPickCount(){ var n=0; Object.keys(gmPicks).forEach(function(k){ n+=gmPicks[k]; }); return n; }
  function gmValid(){
    if(!gmOpt) return false;
    if(gmOpt.type==='random_pool') return true;
    return gmPickCount()===(gmOpt.qty|0||1);
  }
  function gmSyncUi(){
    var ok=document.getElementById('nzsCdrGmOk'), cnt=document.getElementById('nzsCdrGmCount');
    if(ok) ok.disabled=gmViewOnly||!gmValid()||gmBusyFlag;
    if(cnt){
      if(gmOpt&&gmOpt.type==='multi_pick'){ cnt.hidden=false; cnt.textContent=gmPickCount()+' of '+gmOpt.qty+' selected'; }
      else cnt.hidden=true;
    }
  }
  function gmSubList(o){
    var av=optAvail(o), dup=!!o.dup, isMulti=o.type==='multi_pick';
    return '<span class="nzs-cdr-gm__opt-sub" role="group" aria-label="'+(isMulti?'Choose '+o.qty:'Choose flavour')+'">'+ (o.items||[]).map(function(g,sgi){
      var out=g.av===false;
      var qtyUi=(isMulti&&dup&&!out)?'<span class="nzs-cdr-gm__sopt-qty"><button type="button" data-gm-minus="'+g.vid+'" aria-label="Fewer '+esc(g.t)+'">\u2212</button><b data-gm-n="'+g.vid+'">0</b><button type="button" data-gm-plus="'+g.vid+'" aria-label="More '+esc(g.t)+'">+</button></span>':'';
      return '<div class="nzs-cdr-gm__sopt'+(out?' is-out':'')+'" role="radio" style="--gm-i:'+sgi+'" aria-checked="false" data-gm-sub="'+g.vid+'" tabindex="'+(out?'-1':'0')+'"'+(out?' aria-disabled="true"':'')+'><img src="'+esc(g.img)+'" alt="" loading="lazy" width="34" height="34"><span class="nzs-cdr-gm__sopt-name">'+esc(g.t)+(out?' (sold out)':'')+'</span>'+(qtyUi||('<span class="nzs-cdr-gm__sopt-check" aria-hidden="true">'+CHECK_IMG22+'</span>'))+'</div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    }).join('')+'</span>';
  }
  function gmRenderStep(){
    var t=gmQueue[gmIdx]; if(!t||!gmEl) return;
    var title=document.getElementById('nzsCdrGmTitle'), step=document.getElementById('nzsCdrGmStep');
    var list=document.getElementById('nzsCdrGmList'), err=document.getElementById('nzsCdrGmErr');
    if(gmViewOnly){
      title.textContent=t.label||'Free gift';
      step.hidden=false;
      var _need=Math.max(0,t.amt-qualTotal(currentCart||{}));
      step.innerHTML='Add <b>'+money(_need)+'</b> more to unlock';
    } else {
      title.textContent=gmQueue.length>1?(gmQueue.length+' free gifts unlocked'):(t.label||'Free gift')+' unlocked';
      step.hidden=false;
      step.innerHTML='Choose your free gift'+(gmQueue.length>1?'s':'')+' <b>'+(gmIdx+1)+'/'+gmQueue.length+'</b>';
    }
    gmOpt=null; gmPicks={}; if(err) err.hidden=true;
    var live=t.opts.filter(function(o){ return optAvail(o).length; });
    list.innerHTML=live.map(function(o,gmi){
      var av=optAvail(o);
      var img=av[0]?av[0].img:(o.items&&o.items[0]?o.items[0].img:'');
      /* NZS-OFFERS-0820 r9 (Blake): ALWAYS strike a compare-at — the most expensive available
         item in the pool; Choose-N/random pools sum the top-N (dup pools: max x N). */
      var caps=av.map(function(g){ return Math.max(g.cap||0,g.p||0); }).sort(function(a,b){ return b-a; });
      var q=Math.max(1,o.qty|0), capC=0;
      if(q===1) capC=caps[0]||0;
      else if(o.dup) capC=(caps[0]||0)*q;
      else { for(var ci=0;ci<q&&ci<caps.length;ci++) capC+=caps[ci]; }
      var priceRow;
      var pctFree=(o.pct|0)>=100;
      if(pctFree) priceRow=(capC>0?'<s>'+money(capC)+'</s>':'')+'<span class="nzs-cdr-gm__opt-free">Free</span>';
      else priceRow=(capC>0?'<s>'+money(capC)+'</s>':'')+'<span class="nzs-cdr-gm__opt-pct">'+(o.pct|0)+'% OFF</span>';
      var hint='';
      if(o.type==='flavour_pick') hint=': choose flavour'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      if(o.type==='multi_pick') hint=': choose '+o.qty; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      if(o.type==='random_pool') hint=': '+o.qty+' random'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      return '<div class="nzs-cdr-gm__opt" role="radio" tabindex="0" aria-checked="false" style="--gm-i:'+gmi+'" data-gm-opt="'+esc(o.k)+'">'
        +'<img src="'+esc(img)+'" alt="" loading="lazy" width="52" height="52">'
        +'<span class="nzs-cdr-gm__opt-body"><span class="nzs-cdr-gm__opt-name">'+esc(o.label)+'<span style="font-weight:600;color:var(--ink-500,#6b7280)">'+hint+'</span></span>'
        +'<span class="nzs-cdr-gm__opt-price">'+priceRow+'</span></span>'
        +'<span class="nzs-cdr-gm__opt-check" aria-hidden="true">'+CHECK_IMG22+'</span>'
        +(o.type==='flavour_pick'||o.type==='multi_pick'?gmSubList(o):'')
        +'</div>';
    }).join('')||'<div class="nzs-cdr__rv-msg">Nothing available right now</div>';
    gmSyncUi();
  }
  function gmOpen(queue,viewOnly){
    if(!gmEl||!queue||!queue.length) return;
    gmQueue=queue; gmIdx=0; gmBusyFlag=false; gmViewOnly=!!viewOnly; gmLastFocus=document.activeElement;
    gmRenderStep();
    gmEl.hidden=false; gmEl.setAttribute('aria-hidden','false');
    void gmEl.offsetWidth;   /* forced reflow, never rAF (occluded windows starve rAF) */
    gmEl.classList.add('is-in');
    var box=gmEl.querySelector('.nzs-cdr-gm__box');
    if(box){ box.setAttribute('tabindex','-1'); box.focus({preventScroll:true}); }
  }
  function gmClose(){
    if(!gmEl||gmEl.hidden) return;
    gmEl.classList.remove('is-in');
    gmEl.setAttribute('aria-hidden','true');
    gmEl.hidden=true;
    gmBusyFlag=false;
    if(gmLastFocus&&gmLastFocus.focus){ try{ gmLastFocus.focus({preventScroll:true}); }catch(_e){} }
  }
  function gmFind(t,k){ var f=null; (t.opts||[]).forEach(function(o){ if(o.k===k) f=o; }); return f; }
  function gmConfirm(){
    var t=gmQueue[gmIdx]; if(gmViewOnly||!t||!gmOpt||gmBusyFlag||!gmValid()) return;
    var ok=document.getElementById('nzsCdrGmOk'), errEl=document.getElementById('nzsCdrGmErr');
    var picks=gmPicks;
    if(gmOpt.type==='random_pool'){
      /* N random DISTINCT in-stock samples from the configured pool */
      var av=optAvail(gmOpt).slice();
      for(var i=av.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var tmp=av[i]; av[i]=av[j]; av[j]=tmp; }
      picks={}; av.slice(0,Math.max(1,gmOpt.qty|0)).forEach(function(g){ picks[g.vid]=1; });
    }
    var items=Object.keys(picks).filter(function(v){ return picks[v]>0; }).map(function(v){
      return {id:parseInt(v,10),quantity:picks[v],properties:{_nzs_gift:tierProp(t)}};
    });
    if(!items.length) return;
    gmBusyFlag=true; gmSyncUi(); if(window.__nzsLoadOn) window.__nzsLoadOn(ok);
    /* NZS-OFFERS-0820 r11: "Change selection" — a re-pick replaces the previous gift lines
       for this tier (serial removes, then the batched add). First-time picks have none. */
    var oldLines=tierLines(currentCart||{},t);
    var pre=oldLines.reduce(function(p,l){
      return p.then(function(){ return fetch(cartRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:l.key,quantity:0}),__nzsCartGuardHandled:true}).catch(function(){}); });
    },Promise.resolve());
    var add=pre.then(function(){ return window.nzsATC?window.nzsATC.add({items:items},{}):Promise.reject(new Error('Please try again')); });
    add.then(function(){
      gmBusyFlag=false; if(window.__nzsLoadOff) window.__nzsLoadOff(ok);
      croEv('gift_selected',{amt:t.amt,opt:gmOpt.k});
      recsKey=''; fetchCart();
      if(gmIdx<gmQueue.length-1){
        gmIdx++;
        var list=document.getElementById('nzsCdrGmList');
        list.classList.add('is-swap');
        setTimeout(function(){ gmRenderStep(); list.classList.remove('is-swap'); },180);
      } else gmClose();
    }).catch(function(err){
      gmBusyFlag=false; if(window.__nzsLoadOff) window.__nzsLoadOff(ok);
      gmSyncUi();
      if(errEl){ errEl.textContent=(err&&err.message)||"Couldn't add that gift. Try another option"; errEl.hidden=false; } /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    });
  }
  if(gmEl){
    gmEl.addEventListener('click',function(e){
      if(e.target.closest('[data-gm-cancel]')){ gmClose(); return; }
      var t=gmQueue[gmIdx]; if(!t) { if(e.target.closest('#nzsCdrGmOk')) gmConfirm(); return; }
      var plus=e.target.closest('[data-gm-plus]'), minus=e.target.closest('[data-gm-minus]');
      var sub=e.target.closest('[data-gm-sub]');
      var optBtn=e.target.closest('[data-gm-opt]');
      if(plus||minus){
        e.stopPropagation();
        var vid=(plus||minus).getAttribute(plus?'data-gm-plus':'data-gm-minus');
        if(gmOpt&&gmOpt.type==='multi_pick'){
          var cur=gmPicks[vid]||0, tot=gmPickCount();
          if(plus&&tot<(gmOpt.qty|0)) gmPicks[vid]=cur+1;
          if(minus&&cur>0){ gmPicks[vid]=cur-1; if(!gmPicks[vid]) delete gmPicks[vid]; }
          var nEl=gmEl.querySelector('[data-gm-n="'+vid+'"]'); if(nEl) nEl.textContent=gmPicks[vid]||0;
          var host=gmEl.querySelector('[data-gm-sub="'+vid+'"]'); if(host) host.setAttribute('aria-checked',(gmPicks[vid]||0)>0?'true':'false');
          gmSyncUi();
        }
        return;
      }
      if(sub&&!sub.classList.contains('is-out')&&gmOpt){
        var vid2=sub.getAttribute('data-gm-sub');
        if(gmOpt.type==='flavour_pick'){
          gmPicks={}; gmPicks[vid2]=1;
          gmEl.querySelectorAll('[data-gm-sub]').forEach(function(s){ s.setAttribute('aria-checked',s===sub?'true':'false'); });
        } else if(gmOpt.type==='multi_pick'&&!gmOpt.dup){
          if(gmPicks[vid2]){ delete gmPicks[vid2]; sub.setAttribute('aria-checked','false'); }
          else if(gmPickCount()<(gmOpt.qty|0)){ gmPicks[vid2]=1; sub.setAttribute('aria-checked','true'); }
        }
        gmSyncUi();
        return;
      }
      if(optBtn){
        var o=gmFind(t,optBtn.getAttribute('data-gm-opt')); if(!o) return;
        if(gmOpt!==o){ gmOpt=o; gmPicks={};
          if(o.type==='single') gmPicks[o.items[0].vid]=1;
          gmEl.querySelectorAll('[data-gm-opt]').forEach(function(c){
            var on=c===optBtn;
            c.setAttribute('aria-checked',on?'true':'false');
            c.classList.toggle('is-open',on&&(o.type==='flavour_pick'||o.type==='multi_pick'));
          });
          gmEl.querySelectorAll('[data-gm-sub]').forEach(function(s){ s.setAttribute('aria-checked','false'); });
          gmEl.querySelectorAll('[data-gm-n]').forEach(function(n){ n.textContent='0'; });
        }
        gmSyncUi();
        return;
      }
      if(e.target.closest('#nzsCdrGmOk')) gmConfirm();
    });
    gmEl.addEventListener('keydown',function(e){
      if(e.key==='Escape'){ e.stopPropagation(); gmClose(); return; }
      if((e.key==='Enter'||e.key===' ')&&e.target.closest&&e.target.closest('[data-gm-opt],[data-gm-sub]')){ e.preventDefault(); e.target.closest('[data-gm-opt],[data-gm-sub]').click(); return; }
      if(e.key!=='Tab') return;
      var f=[].slice.call(gmEl.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), [role="radio"][tabindex="0"]'));
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && (document.activeElement===first||document.activeElement===gmEl.querySelector('.nzs-cdr-gm__box'))){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });
  }
  /* --- per-render sync: Offers repaint + newly-crossed tier detection --- */
  var _tierSeen={};
  try{ _tierSeen=JSON.parse(sessionStorage.getItem('nzsTierSeen')||'{}')||{}; }catch(_e){ _tierSeen={}; }
  function offersAfterRender(cart){
    if(offersPane&&!offersPane.hidden) renderOffers();
    jmFetch(cart);
    if(!gmEl||!drawer.classList.contains('is-open')) return;
    var sub=qualTotal(cart);
    var toPrompt=[], changed=false;
    REWARDS.forEach(function(t){
      if(!t.opts||!t.opts.length) return;
      var reached=sub>=t.amt;
      if(!reached){ if(_tierSeen[t.amt]){ delete _tierSeen[t.amt]; changed=true; } return; }
      if(tierLines(cart,t).length){ if(!_tierSeen[t.amt]){ _tierSeen[t.amt]=1; changed=true; } return; }
      if(!_tierSeen[t.amt]){
        _tierSeen[t.amt]=1; changed=true;
        if(t.opts.filter(function(o){ return optAvail(o).length; }).length){ toPrompt.push(t); croEv('gift_tier_unlocked',{amt:t.amt}); }
      }
    });
    if(changed){ try{ sessionStorage.setItem('nzsTierSeen',JSON.stringify(_tierSeen)); }catch(_e){} }
    if(toPrompt.length&&gmEl.hidden&&!gmBusyFlag) gmOpen(toPrompt,false);
  }
  /* --- Judge.me review stars: ~1KB aggregate per product, 24h sessionStorage cache, drawer-open
     only, uncached products only. No metafield values exist on this shop (REVAMP backend), and
     the widget API has no batch mode — this is the lightest compliant retrieval. --- */
  var _jm={};
  try{ _jm=JSON.parse(sessionStorage.getItem('nzsJmAgg')||'{}')||{}; }catch(_e){ _jm={}; }
  var JM_TTL=86400000;
  var STAR_ONE='<svg viewBox="0 0 16 16" width="13" height="13"><path fill="currentColor" d="M8 1.4l2 4.1 4.5.6-3.3 3.1.8 4.5L8 11.6l-4 2.1.8-4.5L1.5 6.1 6 5.5z"/></svg>';
  var STARS5=STAR_ONE+STAR_ONE+STAR_ONE+STAR_ONE+STAR_ONE;
  function jmEntry(pid){ var e=_jm[pid]; return (e&&(Date.now()-e.t)<JM_TTL)?e:null; }
  function jmHtml(e){
    if(!e||!(e.n>0)||!(e.a>0)) return '';
    var pctW=Math.max(0,Math.min(100,e.a/5*100));
    return '<div class="nzs-cdr__stars" role="img" aria-label="Rated '+e.a.toFixed(1)+' out of 5 from '+e.n+' review'+(e.n===1?'':'s')+'">'
      +'<span class="nzs-cdr__stars-row" aria-hidden="true" style="color:#d8dde3">'+STARS5
      +'<span class="nzs-cdr__stars-fill" style="width:'+pctW+'%;color:#f5a623">'+STARS5+'</span></span>'
      +'<span class="nzs-cdr__stars-txt" aria-hidden="true">'+e.a.toFixed(1)+' ('+e.n+')</span></div>';
  }
  function jmRowFor(it){ return jmHtml(jmEntry(it.product_id)); }
  var _jmSaveT=null;
  function jmSave(){ clearTimeout(_jmSaveT); _jmSaveT=setTimeout(function(){ try{ sessionStorage.setItem('nzsJmAgg',JSON.stringify(_jm)); }catch(_e){} },400); }
  /* NZS-CDR-CAB-0823: cache-or-fetch a product's review aggregate ONCE. Shared primitive so both the
     cart rows (jmFetch) and the Customers-Also-Bought cards (loadRecs) use one definition — no N+1,
     zeros cached too. Resolves the entry (or null if the shop domain is unavailable). */
  function jmGet(pid){
    var e=jmEntry(pid); if(e) return Promise.resolve(e);
    var sd=(window.Shopify&&Shopify.shop)||''; if(!sd) return Promise.resolve(null);
    return fetch('https://cdn.judge.me/reviews/reviews_for_widget?url='+sd+'&shop_domain='+sd+'&platform=shopify&per_page=0&page=1&product_id='+pid)
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(j){ _jm[pid]={a:parseFloat(j.average_rating)||0,n:j.number_of_reviews|0,t:Date.now()}; jmSave(); return _jm[pid]; })
      .catch(function(){ _jm[pid]={a:0,n:0,t:Date.now()}; jmSave(); return _jm[pid]; });
  }
  function jmFetch(cart){
    if(!drawer.classList.contains('is-open')) return;
    var seen={};
    ((cart&&cart.items)||[]).forEach(function(it){
      var pid=it.product_id; if(!pid||seen[pid]||jmEntry(pid)) return;
      if((it.properties||{})._nzs_gift) return;
      seen[pid]=1;
      jmGet(pid).then(function(){
        var row=itemsEl.querySelector('.nzs-cdr__item[data-pid="'+pid+'"]');
        if(row&&!row.querySelector('.nzs-cdr__stars')&&!row.dataset.lock){
          var h=jmHtml(_jm[pid]);
          if(h){ var head=row.querySelector('.nzs-cdr__item-head'); if(head) head.insertAdjacentHTML('afterend',h); }
        }
      });
    });
  }
  /* --- Recently-Viewed product click: skeleton now (it closes the drawer instantly), navigate.
     NZS-SKCLOSE-0903: was close() + 330ms wait = the drawer visibly sliding off before every nav. --- */
  if(rvBox) rvBox.addEventListener('click',function(e){
    var a=e.target.closest('a[href*="/products/"]');
    if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    e.preventDefault();
    if(window.__nzsNavSkTo) window.__nzsNavSkTo(a.href); else location.assign(a.href);
  });
  function cartShow(){ selectTab('cart',{focus:false}); drawer.classList.add('is-open'); overlay.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); overlay.setAttribute('aria-hidden','false'); toggle.setAttribute('aria-expanded','true'); if(window.__nzsX) window.__nzsX.bind(overlay); }
  function cartHide(){ drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); overlay.setAttribute('aria-hidden','true'); toggle.setAttribute('aria-expanded','false'); if(window.__nzsX) window.__nzsX.unbind(overlay); gmClose(); /* NZS-OFFERS-0820: never leave the gift modal over a closed drawer */ }
  function cartRawClose(){ cartHide(); document.body.style.overflow=''; }
  function cartEnhance(){ if(cartOverlay||!window.nzsOverlay) return; var wasOpen=drawer.classList.contains('is-open'); if(closeBtn) closeBtn.setAttribute('data-nzs-autofocus',''); cartOverlay=window.nzsOverlay.enhance({root:drawer,trigger:toggle,key:'cart',label:'Cart',onOpen:cartShow,onClose:cartHide}); if(wasOpen){ cartRawClose(); cartOverlay.open(); } }
  function open(){ _cartRetryN=0; if(!cartOverlay&&window.nzsOverlay) cartEnhance(); if(cartOverlay){ cartOverlay.open(); } else { if(window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('cart'); cartShow(); document.body.style.overflow='hidden'; window.__nzsSurfaces=window.__nzsSurfaces||{}; window.__nzsSurfaces.cart=cartRawClose; } if(!_cartReady){ itemsEl.innerHTML='<div class="nzs-cdr__empty">Loading\u2026</div>'; } fetchCart(); }
  function close(){ if(!cartOverlay&&window.nzsOverlay) cartEnhance(); if(cartOverlay) cartOverlay.close(); else cartRawClose(); }
  toggle.addEventListener('click', function(e){ if(e && e.isTrusted && drawer.classList.contains('is-open')) close(); else open(); });
  /* NZS-CDR-CLEAR: single click empties the cart (no confirm, by request). Refresh reuses the
     data-act="remove" path exactly — bump _cartSeq to invalidate in-flight /cart.js, then
     render(cart) on a good cart JSON, else fetchCart(). No reload. */
  var clearBtn = document.getElementById('nzsCdrClear');
  if(clearBtn) clearBtn.addEventListener('click',function(){
    /* NZS-SPEED-LDR-CLEAR: disable and show shared dots until every terminal path. */
    function clearBusyOff(){ if(window.__nzsLoadOff) window.__nzsLoadOff(clearBtn); clearBtn.disabled=false; }
    clearBtn.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(clearBtn);
    var seq=++_cartSeq;
    fetch(cartRoot+'cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(cart){ if(seq!==_cartSeq){ clearBusyOff(); return; } if(cart && cart.items && cart.token){ render(cart); } else { fetchCart(); } clearBusyOff(); })
      .catch(function(){ clearBusyOff(); fetchCart(); });
  });
  if(closeBtn) closeBtn.addEventListener('click',close);
  if(overlay) overlay.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!cartOverlay&&drawer.classList.contains('is-open')) cartRawClose(); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',cartEnhance,{once:true}); else cartEnhance();
  /* recommended-for-you one-click add (delegated) */
  var recsRowEl=document.getElementById('nzsCdrRecsRow');
  /* NZS-CDR-RECS-WHEEL (Blake 2026-07-31): a mouse wheel over the strip swipes it
     horizontally instead of fighting the drawer's vertical scroll. */
  if(recsRowEl) recsRowEl.addEventListener('wheel',function(e){ if(!e.deltaY||e.ctrlKey) return; e.preventDefault(); recsRowEl.scrollLeft+=e.deltaY; },{passive:false});
  if(recsRowEl) recsRowEl.addEventListener('click',function(e){
    var btn=e.target.closest('[data-rec-add]'); if(!btn||btn.disabled) return;
    /* NZS-SPEED-LDR-RECS: one label element, one shared loadOn/loadOff state. */
    /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    var card=btn.closest('.nzs-cdr__rec'); if(!card) return;
    var pid=card.getAttribute('data-rec-pid'), price=Number(card.getAttribute('data-rec-price')), vid=parseInt(btn.dataset.recAdd,10), pos=Array.prototype.indexOf.call(recsRowEl.children,card);
    var label=btn.querySelector('.nzs-speed-label');
    btn.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(btn);
    var recLink=card.querySelector('a[href*="/products/"]'); /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    var recMatch=((recLink&&recLink.getAttribute('href'))||'').split('?')[0].match(/\/products\/([^\/?#]+)/);
    var recAdd=window.nzsATC
      ? window.nzsATC.add({items:[{id:parseInt(btn.dataset.recAdd,10),quantity:1}]},{handle:recMatch?recMatch[1]:''})
      : Promise.reject(new Error('Please try again'));
    recAdd.then(function(){ croEv('rec_add',{surface:'cdr',pid:pid,vid:vid,price:price,pos:pos}); if(window.__nzsLoadOff) window.__nzsLoadOff(btn); btn.disabled=false; recsKey=''; fetchCart(); }).catch(function(err){ var message=err.message||"Couldn't add to cart"; if(window.__nzsLoadOff) window.__nzsLoadOff(btn); if(label) label.textContent=message; btn.title=message; setTimeout(function(){ if(!btn.isConnected) return; if(label) label.textContent='Add'; btn.removeAttribute('title'); btn.disabled=false; },2500); }); /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
  });
  /* mobile nav drawer */
  var mBtn = document.getElementById('nzsBurger');
  var mNav = document.getElementById('nzsMnav');
  var mOv = document.getElementById('nzsMnavOverlay');
  var mCl = document.getElementById('nzsMnavClose');
  var moreWrap = document.getElementById('nzsMore');
  var mOverlay = null;
  function isDesktop(){ return window.matchMedia('(min-width:1101px)').matches; }
  function moreSet(o){ if(!moreWrap) return; if(o && window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('more'); moreWrap.classList.toggle('is-open', o); mBtn.classList.toggle('is-active', o); mBtn.setAttribute('aria-expanded', o?'true':'false'); var pn=moreWrap.querySelector('.nzs-more__panel'); if(pn) pn.setAttribute('aria-hidden', o?'false':'true'); }
  function mShow(){ mNav.classList.add('is-open'); mOv.classList.add('is-open'); mNav.setAttribute('aria-hidden','false'); mBtn.setAttribute('aria-expanded','true'); mBtn.classList.add('is-active'); }
  function mHide(){ mNav.classList.remove('is-open'); mOv.classList.remove('is-open'); mNav.setAttribute('aria-hidden','true'); mBtn.setAttribute('aria-expanded','false'); mBtn.classList.remove('is-active'); }
  function mRawClose(){ mHide(); document.body.style.overflow=''; }
  function mEnhance(){ if(mOverlay||!window.nzsOverlay) return; var wasOpen=mNav.classList.contains('is-open'); mOverlay=window.nzsOverlay.enhance({root:mNav,trigger:mBtn,key:'mnav',label:'Menu',onOpen:mShow,onClose:mHide}); if(wasOpen){ mRawClose(); mOverlay.open(); } }
  function mOpen(){ if(!mOverlay&&window.nzsOverlay) mEnhance(); if(mOverlay){ mOverlay.open(); return; } if(window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('mnav'); mShow(); document.body.style.overflow='hidden'; window.__nzsSurfaces=window.__nzsSurfaces||{}; window.__nzsSurfaces.mnav=mRawClose; }
  function mClose(){ if(!mOverlay&&window.nzsOverlay) mEnhance(); if(mOverlay) mOverlay.close(); else mRawClose(); }
  if(mBtn&&mNav){
    mBtn.addEventListener('click',function(e){ e.stopPropagation(); if(isDesktop() && moreWrap){ moreSet(!moreWrap.classList.contains('is-open')); } else { mOpen(); } });
    if(mCl) mCl.addEventListener('click',mClose);
    if(mOv) mOv.addEventListener('click',mClose);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ if(!mOverlay&&mNav.classList.contains('is-open')) mClose(); moreSet(false); } });
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mEnhance,{once:true}); else mEnhance();
  }
  if(moreWrap){
    var mSub=moreWrap.querySelector('[data-more-sub]');
    if(mSub){ var msb=mSub.querySelector('.nzs-more__subbtn'), msp=mSub.querySelector('.nzs-more__subpanel');
      if(msb) msb.addEventListener('click',function(e){ e.stopPropagation(); var o=!mSub.classList.contains('is-open'); mSub.classList.toggle('is-open',o); msb.setAttribute('aria-expanded',o?'true':'false'); if(msp) msp.style.height=o?(msp.scrollHeight+'px'):'0px'; }); }
    var mPanel=moreWrap.querySelector('.nzs-more__panel'); if(mPanel) mPanel.addEventListener('click',function(e){ e.stopPropagation(); });
    document.addEventListener('click',function(){ moreSet(false); });
  }
  /* NZS-MNAV-PANELS: slide-across panels (replaced the Brand/Category accordions) */
  if(mNav){
    var mPanes={}; mNav.querySelectorAll('[data-mpane]').forEach(function(p){ mPanes[p.getAttribute('data-mpane')]=p; });
    var mStack=[];
    function mSet(stack){
      mStack=stack;
      mNav.classList.toggle('has-sub', stack.length>0);
      Object.keys(mPanes).forEach(function(k){
        var i=stack.indexOf(k);
        mPanes[k].classList.toggle('is-on', i>-1 && i===stack.length-1);
        mPanes[k].classList.toggle('is-under', i>-1 && i<stack.length-1);
      });
    }
    mNav.addEventListener('click', function(e){
      var o=e.target.closest('[data-mopen]');
      if(o){ e.preventDefault(); mSet(mStack.concat(o.getAttribute('data-mopen'))); return; }
      if(e.target.closest('[data-mback]')){ mSet(mStack.slice(0,-1)); return; }
      if(e.target.closest('[data-mclose]')){ if(mCl) mCl.click(); }
    });
    /* reset to root after the drawer finishes sliding shut */
    mNav.addEventListener('transitionend', function(e){ if(e.target===mNav && !mNav.classList.contains('is-open') && mStack.length) mSet([]); });
    /* r2: reduced-motion kills the drawer transition (no transitionend) — reset on reopen too */
    if(mBtn) mBtn.addEventListener('click', function(){ if(mStack.length) mSet([]); });
    /* NZS-MNAV-SHEET: bottom-sheet drag — pull the handle/header down >90px to close */
    var dragY=null, dragDY=0;
    mNav.addEventListener('touchstart', function(e){
      if(e.target.closest('button,a')) return;
      var inHead=e.target.closest('.nzs-mnav__head,.nzs-mnav__phead');
      if(!inHead && e.touches[0].clientY - mNav.getBoundingClientRect().top > 110) return; /* NZS-MNAV-SHEET r2 (Blake): 30px grab band was too small -- top 110px now drags (links/buttons still bail above) */
      dragY=e.touches[0].clientY; dragDY=0; mNav.classList.add('is-dragging');
    }, {passive:true});
    var dragRaf=0; /* NZS-MNAV-SMOOTH-0903: coalesce touchmove writes to one per frame */
    mNav.addEventListener('touchmove', function(e){
      if(dragY===null) return;
      dragDY=Math.max(0, e.touches[0].clientY-dragY);
      if(!dragRaf) dragRaf=requestAnimationFrame(function(){ dragRaf=0; if(dragY!==null) mNav.style.transform='translateY('+dragDY+'px)'; });
    }, {passive:true});
    mNav.addEventListener('touchend', function(){
      if(dragY===null) return;
      mNav.classList.remove('is-dragging'); mNav.style.transform='';
      if(dragDY>90) mClose();
      dragY=null; dragDY=0;
    });
  }
  /* NZS-ONEOPEN: register this IIFE's surfaces with the shared registry (created in the mega-menu
     IIFE above; re-guarded here in case that block ever fails to run). Closers only strip state. */
  window.__nzsSurfaces = window.__nzsSurfaces || {};
  if(!cartOverlay) window.__nzsSurfaces.cart = cartRawClose; /* replaced by nzsOverlay.enhance at init */
  window.__nzsSurfaces.more = function(){ moreSet(false); };
  if(mBtn&&mNav&&!mOverlay) window.__nzsSurfaces.mnav = mRawClose; /* replaced by nzsOverlay.enhance at init */
  /* NZS-SPD-0820 item 4: the badge count renders server-side ({{ cart.item_count }} in
     nzs-header.liquid), so the load-time /cart.js is only a re-sync - skip it entirely
     unless a cart cookie exists (anonymous first visits now make zero cart requests). */
  if(/(?:^|; )cart=/.test(document.cookie)) fetch(cartRoot+'cart.js').then(function(r){return r.json();}).then(function(c){ setBadge(c.item_count); });
  window.addEventListener('pageshow', function(e){ if(e.persisted) fetchCart(); });
})();
